/*
 * inselvolt Kompatibilitätsberater — UI-Schicht.
 *
 * Drei Aufgaben, nach Häufigkeit geordnet (Reiter oben):
 *   1. „Speicher zum Wechselrichter finden"  — Hauptfall, beim Laden sofort offen
 *   2. „Speicher erweitern"                  — Ausbaustufen des vorhandenen Turms
 *   3. „Wechselrichter zum Speicher finden"  — Gegenrichtung
 *
 * Aufbau: Auswahl oben (nach dem ersten Ergebnis zur Zusammenfassung eingeklappt),
 * darunter Ergebnisliste mit Filtern und Sortierung, Details je Kombination im
 * Overlay. Das Ergebnis aktualisiert sich sofort — es gibt keinen „Weiter"-Schritt,
 * der zwischen Auswahl und Antwort steht.
 *
 * Regeln dieser Schicht:
 *  - Alle dynamischen Inhalte via textContent — nie innerHTML.
 *  - Die UI ordnet, filtert und erklärt; jede Kompatibilitäts-, Leistungs- und
 *    Preisaussage kommt unverändert aus der Engine.
 *  - Unbekannte Werte werden benannt („Wert offen"), nie durch 0 oder eine
 *    Schätzung ersetzt, und nie weggefiltert.
 *  - Redaktionelle inselvolt-Hinweise (daten/hinweise.js) stehen sichtbar getrennt
 *    von Herstellerbelegen.
 */
(function () {
  'use strict';

  /*
   * Ziel-Adressen sind konfigurierbar: In der Standalone-Fassung absolute URLs,
   * in der Shopify-Section relative Pfade (/products/…), damit Links im Shop
   * nicht über die öffentliche Domain umgeleitet werden und die Sitzung erhalten
   * bleibt. Gesetzt wird das über window.IV_BERATER_KONFIG.
   */
  function konfigWert(name, standard) {
    var k = window.IV_BERATER_KONFIG || {};
    return k[name] || standard;
  }
  var KONTAKT_URL = konfigWert('kontakt_url', 'https://inselvolt.de/pages/kontakt');

  var MAX_VERGLEICH = 4;


  var AUFGABEN = [
    {
      id: 'speicher_finden',
      icon: 'speicher',
      reiter: 'Speicher zum Wechselrichter finden',
      reiter_unter: 'Sie haben einen Wechselrichter',
      kurz: 'Speicher finden',
      frage: 'Welchen Wechselrichter haben Sie?',
      hilfe: 'Der Berater zeigt alle Speicher, die der Hersteller für dieses Gerät bestätigt hat.',
    },
    {
      id: 'erweitern',
      icon: 'erweitern',
      reiter: 'Speicher erweitern',
      reiter_unter: 'Sie haben schon einen Speicher',
      kurz: 'Erweitern',
      frage: 'Welchen Speicher haben Sie und an welchem Wechselrichter hängt er?',
      hilfe: 'Der Berater zeigt, welche größeren Ausbaustufen für diese Kombination bestätigt sind.',
    },
    {
      id: 'wr_finden',
      icon: 'wechselrichter',
      reiter: 'Wechselrichter zum Speicher finden',
      reiter_unter: 'Sie haben einen Speicher',
      kurz: 'Wechselrichter finden',
      frage: 'Welchen Speicher haben Sie?',
      hilfe: 'Der Berater zeigt alle Wechselrichter, die der Hersteller für diesen Speicher bestätigt hat.',
    },
  ];

  // Mindest-Entladeleistung als Filter statt als eigener Wizard-Schritt.
  /* Facetten-Rechnung lebt seit E6 in app/filterwerk.js (rein, getestet). */
  var LEISTUNGS_STUFEN = window.IVBeraterFilterwerk.LEISTUNGS_STUFEN;

  /*
   * Name jeder Sortierung — auch der Richtungen, die das Auswahlfeld nicht als
   * Voreinstellung anbietet. Ohne diese Liste zeigte das Feld „Empfehlung",
   * sobald über einen Spaltenkopf absteigend sortiert wurde: Der Wert stand im
   * Zustand, aber es gab keinen passenden Eintrag zum Anzeigen.
   */
  var SORTIER_NAMEN = {
    empfehlung: 'Empfehlung',
    preis_auf: 'Preis: niedrigster zuerst',
    preis_ab: 'Preis: höchster zuerst',
    eur_kwh_auf: 'Preis pro kWh: niedrigster zuerst',
    eur_kwh_ab: 'Preis pro kWh: höchster zuerst',
    kapazitaet_auf: 'Kapazität: kleinste zuerst',
    kapazitaet_ab: 'Kapazität: größte zuerst',
    entladen_auf: 'Entladeleistung: niedrigste zuerst',
    entladen_ab: 'Entladeleistung: höchste zuerst',
    laden_auf: 'Ladeleistung: niedrigste zuerst',
    laden_ab: 'Ladeleistung: höchste zuerst',
    garantie_auf: 'Garantie: kürzeste zuerst',
    garantie_ab: 'Garantie: längste zuerst',
    wr_preis_auf: 'Preis: niedrigster zuerst',
    wr_preis_ab: 'Preis: höchster zuerst',
    system_eur_kwh_auf: 'Preis pro kWh (System): niedrigster zuerst',
    system_eur_kwh_ab: 'Preis pro kWh (System): höchster zuerst',
    gesamt_auf: 'System gesamt: günstigster zuerst',
    gesamt_ab: 'System gesamt: teuerster zuerst',
    ac_auf: 'AC-Nennleistung: niedrigste zuerst',
    ac_ab: 'AC-Nennleistung: höchste zuerst',
    verfuegbar_auf: 'Verfügbarkeit: nicht lieferbare zuerst',
    verfuegbar_ab: 'Verfügbarkeit: lieferbare zuerst',
  };

  var SORTIER_OPTIONEN = {
    speicher: [
      { id: 'empfehlung', name: 'Empfehlung' },
      { id: 'preis_auf', name: 'Preis: niedrigster zuerst' },
      { id: 'eur_kwh_auf', name: 'Preis pro kWh: niedrigster zuerst' },
      { id: 'kapazitaet_ab', name: 'Kapazität: größte zuerst' },
      { id: 'kapazitaet_auf', name: 'Kapazität: kleinste zuerst' },
      { id: 'entladen_ab', name: 'Entladeleistung: höchste zuerst' },
      { id: 'laden_ab', name: 'Ladeleistung: höchste zuerst' },
      { id: 'garantie_ab', name: 'Garantie: längste zuerst' },
    ],
    wr: [
      { id: 'empfehlung', name: 'Empfehlung' },
      { id: 'wr_preis_auf', name: 'Preis: niedrigster zuerst' },
      { id: 'system_eur_kwh_auf', name: 'Preis pro kWh (System): niedrigster zuerst' },
      { id: 'entladen_ab', name: 'Entladeleistung: höchste zuerst' },
      { id: 'laden_ab', name: 'Ladeleistung: höchste zuerst' },
      { id: 'ac_ab', name: 'AC-Nennleistung: höchste zuerst' },
    ],
  };

  // ---------------------------------------------------------------- Helfer ---

  /*
   * Die gemeinsamen Bausteine stehen seit 2026-08-15 in app/familien.js: el(),
   * Icons, (i)-Hilfe, Herstellermarke, Spannungsklassen, Formate, Shop-Links —
   * und darauf aufbauend die Baureihen-Kachel mit ihrer Varianten-Tabelle.
   *
   * Grund ist das Produktseiten-Overlay: Es zeigt dieselben Baureihen und hatte
   * dafür eine zweite, eigene Darstellung. Zwei Auszeichnungen für dieselbe
   * Aussage laufen zwangsläufig auseinander, und für den Kunden waren es zwei
   * Produkte statt einem.
   *
   * Hier stehen nur noch die Namen — der Rumpf dieser Datei benutzt sie
   * unverändert weiter.
   */
  var F = (typeof window !== 'undefined' && window.IVBeraterFamilien)
    || (typeof require === 'function' ? require('./familien.js') : null);

  var el = F.el;
  var knopf = F.knopf;
  var leere = F.leere;
  var icon = F.icon;
  var hilfe = F.hilfe;
  var herstellerMarke = F.herstellerMarke;
  var KLASSEN = F.KLASSEN;
  var klasse = F.klasse;
  var istZahl = F.istZahl;
  var kw = F.kw;
  var kwh = F.kwh;
  var euro = F.euro;
  var euroGenau = F.euroGenau;
  var datumLang = F.datumLang;
  var shopLink = F.shopLink;
  var produktAdresse = F.produktAdresse;
  var FEHLT = F.FEHLT;

  function kontaktLink(text, klasseName, url) {
    return F.kontaktLink(text, klasseName, url || KONTAKT_URL);
  }


  /*
   * Ein Ereignis, zwei Empfänger: der dataLayer (GA4, Google Ads) und Microsoft
   * Clarity (Aufzeichnung, Heatmap, Nutzungstiefe). Beide bekommen dieselben
   * Namen aus derselben Zeile — eine zweite Ereignisliste würde früher oder
   * später eine andere Wahrheit erzählen als diese.
   */
  function emit(ivEvent, daten) {
    try {
      window.dataLayer = window.dataLayer || [];
      var event = { event: 'iv_berater', iv_event: ivEvent };
      for (var k in daten) { if (Object.prototype.hasOwnProperty.call(daten, k)) event[k] = daten[k]; }
      window.dataLayer.push(event);
      if (window.IV_CLARITY) window.IV_CLARITY.melde('berater', ivEvent, daten);
    } catch (fehler) { /* Tracking darf die Seite nie brechen */ }
  }

  /*
   * Wie emit(), meldet aber nur, wenn sich die Signatur seit der letzten Meldung
   * geändert hat.
   *
   * Grund: Ereignisse wie „ergebnis_angezeigt" stehen in der Zeichenfunktion und
   * liefen deshalb bei jedem Neuzeichnen erneut — also auch beim Umsortieren, beim
   * Setzen eines Filters oder beim Aufklappen einer Gruppe. Für die Anzeige ist das
   * richtig, als Zählwert ist es falsch: Eine einzige Beratung hätte ein Dutzend
   * „Ergebnis angezeigt" erzeugt und jede darauf gestützte Auswertung verzerrt.
   *
   * Die Signatur beschreibt daher die ANTWORT (was der Kunde wissen wollte), nicht
   * die Darstellung (wie er sie gerade sortiert). Wechselt er tatsächlich den
   * Wechselrichter oder den Speicher, ist das eine neue Frage und wird neu gemeldet.
   */
  var zuletztGemeldet = {};

  function emitEinmalig(ivEvent, signatur, daten) {
    if (zuletztGemeldet[ivEvent] === signatur) return;
    zuletztGemeldet[ivEvent] = signatur;
    emit(ivEvent, daten);
  }

  function auswahl(id, beschriftung, optionen, wert, beiWechsel, platzhalter) {
    var huelle = el('div', 'iv-feld');
    var lab = el('label', 'iv-feld__label', beschriftung);
    lab.setAttribute('for', id);
    var sel = el('select', 'iv-select');
    sel.id = id;
    if (platzhalter) {
      var p = el('option', null, platzhalter);
      p.value = '';
      sel.appendChild(p);
    }
    function haengeOption(ziel, o) {
      var opt = el('option', null, o.name);
      opt.value = o.id;
      if (o.id === wert) opt.selected = true;
      ziel.appendChild(opt);
    }
    optionen.forEach(function (o) {
      /*
       * Ein Eintrag { gruppe, optionen } wird zur <optgroup>: So stehen die
       * Sortiments-Hersteller vorn und der Rest folgt sichtbar abgesetzt,
       * ohne dass die Auswahl-Logik davon etwas mitbekommt.
       */
      if (o.gruppe) {
        var og = document.createElement('optgroup');
        og.label = o.gruppe;
        o.optionen.forEach(function (u) { haengeOption(og, u); });
        sel.appendChild(og);
        return;
      }
      haengeOption(sel, o);
    });
    sel.disabled = optionen.length === 0;
    sel.addEventListener('change', function () { beiWechsel(sel.value || null); });
    huelle.appendChild(lab);
    huelle.appendChild(sel);
    return huelle;
  }

  // ------------------------------------------------------------- Datenwege ---

  /*
   * Rangfolge der Hersteller. Die Liste liegt in der Engine
   * (WESENTLICHE_HERSTELLER), weil die Produktseite dieselbe Ordnung braucht —
   * eine zweite Kopie hier würde auseinanderlaufen. LOGOS bleibt in dieser
   * Schicht, weil Dateinamen eine Sache der Oberfläche sind; ein Test hält
   * beide Listen deckungsgleich.
   */
  function herstellerRang(name) {
    return window.IVBeraterEngine.herstellerRang(name);
  }

  var WEITERE_HERSTELLER = 'Weitere Hersteller';

  function nachRang(a, b) {
    var ra = herstellerRang(a.name || a.id);
    var rb = herstellerRang(b.name || b.id);
    if (ra !== rb) return ra - rb;
    return String(a.name).localeCompare(String(b.name), 'de');
  }

  function herstellerListe(familien) {
    var gesehen = {};
    var liste = [];
    familien.forEach(function (f) {
      if (!gesehen[f.hersteller]) { gesehen[f.hersteller] = true; liste.push({ id: f.hersteller, name: f.hersteller }); }
    });
    return liste.sort(nachRang);
  }

  /*
   * Zweistufige Hersteller-Auswahl im Dropdown: erst die Marken mit Logo, ohne
   * Beschriftung; darunter, sichtbar abgesetzt, alle übrigen aus den
   * Kompatibilitätslisten. Bei über 40 Einträgen fanden Kunden die gängigen
   * Marken sonst nur durch Scrollen.
   */
  function herstellerGruppen(liste) {
    var vorn = liste.filter(function (h) { return herstellerRang(h.id) === 0; });
    var weitere = liste.filter(function (h) { return herstellerRang(h.id) === 1; });
    if (!vorn.length || !weitere.length) return liste;
    return vorn.concat([{ gruppe: WEITERE_HERSTELLER, optionen: weitere }]);
  }

  function familienVon(familien, hersteller) {
    return familien
      .filter(function (f) { return f.hersteller === hersteller; })
      .map(function (f) { return { id: f.id, name: f.name }; })
      .sort(function (a, b) { return a.name.localeCompare(b.name, 'de'); });
  }

  function findeFamilie(familien, id) {
    for (var i = 0; i < familien.length; i++) if (familien[i].id === id) return familien[i];
    return null;
  }

  // ------------------------------------------------------------------ Start --

  function start() {
    var wurzel = document.getElementById('berater-app');
    var daten = window.IVBeraterDaten;
    var engine = window.IVBeraterEngine;
    var preise = window.IVBeraterPreise || null;
    var hinweise = window.IVBeraterHinweise || null;
    if (!wurzel) return;
    if (!daten || !engine) { zeigeFallback(wurzel); return; }

    /*
     * Preisherkunft: Bis der Live-Abruf antwortet, rechnen wir mit der
     * gespeicherten Datei — die Seite ist also sofort benutzbar. Kommt der
     * Live-Abruf durch, wird mit den frischen Preisen neu gezeichnet; scheitert
     * er, bleibt die Datei und die Herkunft steht sichtbar über dem Ergebnis.
     * Übergänge und Texte: app/preisstand.js (rein, getestet, seit E6).
     */
    var PS = window.IVBeraterPreisstand;
    var preisHerkunft = PS.start(preise);

    var FW = window.IVBeraterFilterwerk;
    /* Zustand und Übergänge: app/ui-zustand.js (rein, getestet, seit E6).
     * Die Closures hier halten dieselbe Objektreferenz — die Übergänge
     * verändern in place, gezeichnet wird weiterhin explizit. */
    var UZ = window.IVBeraterZustand;

    var zustand = UZ.neuerZustand(FW.neuerFilter());

    // ---- Grundgerüst ----
    leere(wurzel);

    /*
     * Drei nummerierte Schritte über den festen Bereichen: Die Zahl gibt dem
     * Kunden das Gerüst („wo bin ich, was kommt noch"), ohne den Ablauf zu
     * verändern — die Bereiche selbst zeichnen sich weiter selbst.
     */
    /*
     * Vier Zahlen, alle aus der Datenbasis gerechnet — keine gepflegte Angabe,
     * die still veralten könnte. Bewusst ohne Werbeaussage: Was hier steht, ist
     * abzählbar, und der Datenstand steht daneben, damit man es nachprüfen kann.
     */
    function baueKennzahlen() {
      var geraete = 0;
      daten.wechselrichter.forEach(function (f) { geraete += (f.varianten || []).length; });
      var groessen = 0;
      daten.speicher.forEach(function (f) { groessen += (f.groessen || []).length; });
      var marken = {};
      daten.wechselrichter.forEach(function (f) { marken[f.hersteller] = true; });
      daten.speicher.forEach(function (f) { marken[f.hersteller] = true; });

      var streifen = el('div', 'iv-datenstreifen');
      [
        [String(geraete), 'Wechselrichter'],
        [String(groessen), 'Speichergrößen'],
        [String(Object.keys(marken).length), 'Hersteller'],
        [String(daten.freigaben.length), 'belegte Freigaben'],
      ].forEach(function (paar) {
        var zelle = el('div', 'iv-datenstreifen__zelle');
        zelle.appendChild(el('span', 'iv-datenstreifen__zahl', paar[0]));
        zelle.appendChild(el('span', 'iv-datenstreifen__wort', paar[1]));
        streifen.appendChild(zelle);
      });

      var fuss = el('p', 'iv-datenstreifen__fuss');
      fuss.appendChild(document.createTextNode('Ausschließlich aus Hersteller-Dokumenten. Datenstand '));
      fuss.appendChild(el('strong', null, datumLang(daten.stand)));
      streifen.appendChild(fuss);
      return streifen;
    }

    function schrittKopf(nummer, titel) {
      var kopf = el('div', 'iv-schritt');
      kopf.appendChild(el('span', 'iv-schritt__nr', String(nummer)));
      kopf.appendChild(el('span', 'iv-schritt__titel', titel));
      return kopf;
    }

    var reiterLeiste = el('div', 'iv-reiter');
    reiterLeiste.setAttribute('role', 'tablist');
    reiterLeiste.setAttribute('aria-label', 'Was möchten Sie herausfinden?');
    var auswahlBereich = el('section', 'iv-auswahl');
    var ergebnisBereich = el('section', 'iv-ergebnis');
    ergebnisBereich.setAttribute('aria-live', 'polite');
    ergebnisBereich.setAttribute('aria-busy', 'false');
    /*
     * Kennzahlen-Streifen. Überschrift, Einleitung und Bild pflegt inselvolt im
     * Theme-Editor über diesem Abschnitt — die ZAHLEN dürfen dort nicht stehen:
     * Sie veralten mit jedem Datenupdate, und niemand pflegt sie nach. Also
     * kommen sie aus der Datenbasis und dem berechneten Datenstand.
     */
    wurzel.appendChild(baueKennzahlen());
    wurzel.appendChild(schrittKopf(1, 'Welche Art von Suche?'));
    wurzel.appendChild(reiterLeiste);
    wurzel.appendChild(schrittKopf(2, 'Auswahlkriterien angeben'));
    wurzel.appendChild(auswahlBereich);
    wurzel.appendChild(schrittKopf(3, 'Ergebnis'));
    wurzel.appendChild(ergebnisBereich);

    var overlay = baueOverlay();
    document.body.appendChild(overlay.knoten);

    // ------------------------------------------------------- Reiter (Aufgabe)

    function zeichneReiter() {
      leere(reiterLeiste);
      AUFGABEN.forEach(function (a) {
        var b = knopf('iv-reiter__knopf' + (zustand.aufgabe === a.id ? ' iv-reiter__knopf--aktiv' : ''), null, function () {
          /*
           * Derselbe Reiter noch einmal war bisher ein Klick ins Nichts — und
           * damit der häufigste tote Klick der Seite (August 2026: 18 von 59,
           * mobil 10 von 26). Er ist keine Fehlbedienung: Wer den Reiter
           * anklickt, auf dem er ohnehin steht, meint „hier geht es los".
           * Also Auswahl aufklappen und den Fokus dorthin setzen. Gemeldet wird
           * dabei NICHTS: `aufgabe_gewaehlt` bezeichnet den Wechsel, und ein
           * Ereignis für „nicht gewechselt" würde genau die Zahl verwässern,
           * an der wir die Aufgabenverteilung ablesen.
           */
          if (!UZ.wechsleAufgabe(zustand, a.id)) {
            if (UZ.oeffneAuswahl(zustand)) zeichneAlles();
            fokussiereAuswahl();
            return;
          }
          emit('aufgabe_gewaehlt', { iv_aufgabe: a.id });
          schreibeHash();
          zeichneAlles();
        });
        b.appendChild(icon(a.icon, 'iv-reiter__icon'));
        var texte = el('span', 'iv-reiter__texte');
        texte.appendChild(el('span', 'iv-reiter__titel', a.reiter));
        b.appendChild(texte);
        b.setAttribute('role', 'tab');
        b.setAttribute('aria-selected', zustand.aufgabe === a.id ? 'true' : 'false');
        reiterLeiste.appendChild(b);
      });
    }

    // ------------------------------------------------------- Auswahl (Setup)

    /*
     * In der Ergebnisliste kommen die beiden Spannungswelten nie gemeinsam vor —
     * dafür sorgen die Freigaben. In der AUSWAHL stehen sie aber nebeneinander,
     * und dort muss erkennbar sein, womit man es zu tun hat.
     */
    function mitKlasse(eintrag, familie) {
      if (!familie || engine.spannungsklasse(familie) !== 'niedervolt') return eintrag;
      return { id: eintrag.id, name: eintrag.name + '  ·  48 V' };
    }

    function aufgabeJetzt() {
      for (var i = 0; i < AUFGABEN.length; i++) if (AUFGABEN[i].id === zustand.aufgabe) return AUFGABEN[i];
      return AUFGABEN[0];
    }


    function auswahlVollstaendig() {
      return UZ.auswahlVollstaendig(zustand);
    }

    /*
     * Auswahl der freigegebenen Wechselrichter zu einem vorhandenen Speicher.
     * In der Erweiterung ist alles andere Unsinn: Der Kunde hat diese Geräte
     * bereits zusammen laufen — ein Gerät anzubieten, für das die Kombination
     * nie freigegeben war, würde ihn in die Irre führen.
     */
    function freigegebeneWrFuerAuswahl() {
      if (!zustand.spFamilie || !zustand.spGroesse) return null;
      var e = engine.wrFuerSpeicher(daten, zustand.spFamilie, zustand.spGroesse, 'standard', preise);
      if (!e || e.fehler) return null;
      var familien = {};
      var varianten = {};
      var herstellerMitTreffer = {};
      e.freigegeben.forEach(function (x) {
        familien[x.wr_familie_id] = true;
        varianten[x.wr_variante_id] = true;
        herstellerMitTreffer[x.hersteller] = true;
      });
      return { familien: familien, varianten: varianten, hersteller: herstellerMitTreffer, anzahl: e.freigegeben.length };
    }

    /*
     * ------------------------------------------------- Geräte-Suchfeld ------
     *
     * Der Katalog führt 191 Wechselrichter-Geräte und 138 Speichergrößen. Drei
     * abhängige Auswahlfelder waren dafür der einzige Weg — wer die
     * Typenbezeichnung kennt, musste sie trotzdem in drei Schritten
     * zusammenklicken. Das Suchfeld ist deshalb der Haupteinstieg; die
     * Auswahlfelder bleiben darunter als Rückfall für alle, die ihr Gerät nur
     * ungefähr kennen.
     *
     * Bewusst OHNE Absendeknopf: Mit der Auswahl steht das Ergebnis fest, es
     * gibt danach nichts mehr zu entscheiden.
     *
     * Die Trefferliste läuft über engine.suche() — dieselbe Funktion und
     * dieselbe Geräteliste wie auf der Produktseite. Eine zweite Suchlogik
     * würde auseinanderlaufen.
     */
    var MAX_VORSCHLAEGE = 8;

    /* Der Listeneintrag zur aktuell gewählten Kombination, falls es einen gibt. */
    function aktuellerTreffer(liste, typ) {
      var wert = typ === 'wr'
        ? zustand.wrVariante
        : (zustand.spFamilie && zustand.spGroesse ? zustand.spFamilie + '~' + zustand.spGroesse : null);
      if (!wert) return null;
      for (var i = 0; i < liste.length; i++) if (liste[i].wert === wert) return liste[i];
      return null;
    }

    function bauGeraetesuche(ziel, typ, erlaubt, beiWahl) {
      var liste = engine.geraeteliste(daten, typ).filter(function (e) {
        if (!erlaubt) return true;
        return typ === 'wr' ? !!erlaubt.varianten[e.wert] : true;
      });

      var huelle = el('div', 'iv-suche');
      var feldId = 'iv-suche-' + typ;
      var listenId = feldId + '-treffer';

      var beschriftung = el('label', 'iv-feld__label',
        typ === 'wr' ? 'Wechselrichter suchen' : 'Speicher suchen');
      beschriftung.setAttribute('for', feldId);
      huelle.appendChild(beschriftung);

      var box = el('div', 'iv-suche__box');
      box.appendChild(icon('suche', 'iv-suche__symbol'));

      var feld = el('input', 'iv-suche__feld');
      feld.type = 'text';
      feld.id = feldId;
      feld.autocomplete = 'off';
      /*
       * Steht schon eine Auswahl, trägt das Feld sie ein. Sonst stünde nach dem
       * Treffer wieder der Platzhalter da und der Kunde sähe nicht mehr, was er
       * gewählt hat — die Auswahlfelder zeigten das früher von selbst.
       */
      var gewaehlt = aktuellerTreffer(liste, typ);
      if (gewaehlt) feld.value = gewaehlt.hersteller + ' ' + gewaehlt.name;
      feld.placeholder = typ === 'wr'
        ? 'Hersteller oder Typ, z. B. „Fronius Symo 10“ oder „SH10RT“'
        : 'Hersteller oder Typ, z. B. „BYD HVS 10.2“ oder „Tower S3“';
      feld.setAttribute('role', 'combobox');
      feld.setAttribute('aria-expanded', 'false');
      feld.setAttribute('aria-controls', listenId);
      feld.setAttribute('aria-autocomplete', 'list');
      box.appendChild(feld);

      /*
       * Die Lupe und der Rand um das Feld sahen anklickbar aus und waren es
       * nicht — beides tauchte im August 2026 in den toten Klicks auf. Ein
       * Klick irgendwo in den Kasten gehört ins Eingabefeld. `mousedown` mit
       * `preventDefault` statt `click`: Sonst setzt der Browser den Fokus
       * zuerst auf den Kasten und nimmt ihn dem Feld gleich wieder weg. Das
       * Feld selbst und das Kreuz behalten ihren eigenen Klick.
       */
      box.addEventListener('mousedown', function (ereignis) {
        var ziel = ereignis.target;
        if (ziel === feld) return;
        if (ziel && typeof ziel.closest === 'function' && ziel.closest('.iv-suche__leeren')) return;
        ereignis.preventDefault();
        feld.focus();
      });

      /*
       * Das Kreuz löscht Eingabe UND Auswahl. Nur den Text zu leeren hinterließe
       * ein leeres Feld über einem Ergebnis, das weiterhin zu einem Gerät gehört —
       * der Kunde sähe nicht mehr, worauf sich die Liste bezieht.
       */
      var leeren = knopf('iv-suche__leeren', null, function () {
        feld.value = '';
        if (gewaehlt) {
          if (typ === 'wr') UZ.leereWr(zustand);
          else UZ.leereSpeicher(zustand);
          schreibeHash();
          zeichneAlles();
          return;
        }
        zeichneTreffer();
        feld.focus();
      });
      leeren.appendChild(icon('schliessen', 'iv-suche__leeren-symbol'));
      leeren.setAttribute('aria-label', gewaehlt ? 'Auswahl entfernen' : 'Eingabe löschen');
      leeren.hidden = !feld.value;
      box.appendChild(leeren);
      huelle.appendChild(box);

      var treffer = el('ul', 'iv-suche__treffer');
      treffer.id = listenId;
      treffer.setAttribute('role', 'listbox');
      treffer.hidden = true;
      huelle.appendChild(treffer);

      var aktiv = -1;
      var sichtbar = [];

      /*
       * Rangfolge auch hier: Marken mit Logo zuerst. Ohne das stünde bei
       * „10 kW" eine unbekannte Baureihe über der gesuchten — die Suche würde
       * die Ordnung unterlaufen, die überall sonst gilt.
       */
      function sortiereTreffer(gefunden) {
        return gefunden.slice().sort(function (a, b) {
          var ra = herstellerRang(a.hersteller), rb = herstellerRang(b.hersteller);
          if (ra !== rb) return ra - rb;
          if (a.hersteller !== b.hersteller) return a.hersteller.localeCompare(b.hersteller, 'de');
          return String(a.name).localeCompare(String(b.name), 'de', { numeric: true });
        });
      }

      function waehle(eintrag) {
        feld.value = eintrag.hersteller + ' ' + eintrag.name;
        schliesse();
        beiWahl(eintrag.wert);
      }

      function schliesse() {
        treffer.hidden = true;
        feld.setAttribute('aria-expanded', 'false');
        aktiv = -1;
      }

      function markiere(i) {
        aktiv = i;
        var kinder = treffer.children;
        for (var k = 0; k < kinder.length; k++) {
          var an = k === i;
          kinder[k].className = 'iv-suche__eintrag' + (an ? ' iv-suche__eintrag--aktiv' : '');
          kinder[k].setAttribute('aria-selected', an ? 'true' : 'false');
        }
        if (i >= 0 && kinder[i] && kinder[i].scrollIntoView) {
          kinder[i].scrollIntoView({ block: 'nearest' });
        }
      }

      function zeichneTreffer() {
        var text = feld.value;
        leeren.hidden = !text;
        leere(treffer);
        aktiv = -1;

        if (!text.trim()) { schliesse(); return; }

        // Erst ohne Grenze suchen: Die Gesamtzahl gehört in die Fußzeile,
        // sonst wirkt „8 Treffer" wie das ganze Ergebnis.
        var alle = sortiereTreffer(engine.suche(liste, text, 0));
        sichtbar = alle.slice(0, MAX_VORSCHLAEGE);

        if (!alle.length) {
          /*
           * Kein Treffer ist bei 329 Geräten ein häufiger Zustand und keine
           * Sackgasse: ehrliche Lücke plus Kontaktweg, nie eine erfundene
           * „Volltextsuche", die es nicht gibt.
           */
          var leerEintrag = el('li', 'iv-suche__leer');
          /*
           * Zwei verschiedene Lagen, zwei verschiedene Sätze. In der
           * eingeschränkten Auswahl (Erweiterung) ist das Gerät sehr wohl im
           * Katalog — es ist nur für DIESEN Speicher nicht bestätigt. „Kein
           * Gerät dieses Namens" wäre dort schlicht falsch und würde nebenbei
           * die Invariante verletzen, dass „nicht gelistet" nie „passt nicht"
           * heißt.
           */
          leerEintrag.appendChild(el('p', 'iv-suche__leer-titel', erlaubt
            ? 'Für diesen Speicher nicht bestätigt'
            : 'Kein Gerät dieses Namens im Katalog'));
          leerEintrag.appendChild(el('p', 'iv-suche__leer-text', erlaubt
            ? 'Hier stehen nur Geräte, die der Hersteller für genau diese Speichergröße '
              + 'bestätigt hat. Dass Ihres nicht dabei ist, heißt nicht, dass es nicht '
              + 'funktioniert. Uns liegt dafür nur kein Dokument vor.'
            : 'Wir führen nur Geräte, die in einer Herstellerliste stehen. Fehlt Ihres, '
              + 'prüfen wir die Kombination kostenlos beim Hersteller.'));
          var pfad = el('a', 'iv-suche__leer-link', 'Kostenlos prüfen lassen');
          pfad.href = KONTAKT_URL;
          leerEintrag.appendChild(pfad);
          treffer.appendChild(leerEintrag);
          treffer.hidden = false;
          feld.setAttribute('aria-expanded', 'true');
          return;
        }

        sichtbar.forEach(function (e, i) {
          var zeile = el('li', 'iv-suche__eintrag');
          zeile.setAttribute('role', 'option');
          zeile.setAttribute('aria-selected', 'false');
          zeile.appendChild(herstellerMarke(e.hersteller, 'iv-suche__marke'));
          var texte = el('span', 'iv-suche__texte');
          texte.appendChild(el('span', 'iv-suche__name', e.name));
          var unter = e.baureihe + (e.zusatz ? '  ·  ' + e.zusatz : '');
          texte.appendChild(el('span', 'iv-suche__unter', unter));
          zeile.appendChild(texte);
          zeile.addEventListener('mousedown', function (ev) { ev.preventDefault(); waehle(e); });
          zeile.addEventListener('mouseenter', function () { markiere(i); });
          treffer.appendChild(zeile);
        });

        if (alle.length > sichtbar.length) {
          var rest = el('li', 'iv-suche__mehr',
            'und ' + (alle.length - sichtbar.length) + ' weitere — Eingabe verfeinern');
          treffer.appendChild(rest);
        }

        treffer.hidden = false;
        feld.setAttribute('aria-expanded', 'true');
      }

      feld.addEventListener('input', zeichneTreffer);
      feld.addEventListener('focus', function () {
        // Steht die getroffene Wahl im Feld, wird sie markiert: Tippen ersetzt
        // sie dann sofort, statt sich hinten anzuhängen.
        if (gewaehlt && feld.value === gewaehlt.hersteller + ' ' + gewaehlt.name) feld.select();
        zeichneTreffer();
      });
      feld.addEventListener('blur', function () { window.setTimeout(schliesse, 120); });
      feld.addEventListener('keydown', function (ev) {
        if (ev.key === 'Escape') { schliesse(); return; }
        if (!sichtbar.length || treffer.hidden) return;
        if (ev.key === 'ArrowDown') { ev.preventDefault(); markiere((aktiv + 1) % sichtbar.length); }
        else if (ev.key === 'ArrowUp') { ev.preventDefault(); markiere(aktiv <= 0 ? sichtbar.length - 1 : aktiv - 1); }
        else if (ev.key === 'Enter' && aktiv >= 0) { ev.preventDefault(); waehle(sichtbar[aktiv]); }
      });

      ziel.appendChild(huelle);
    }

    /* Ein Suchtreffer setzt denselben Zustand wie die drei Auswahlfelder. */
    function uebernimmWrTreffer(variantenId) {
      UZ.setzeWrTreffer(zustand, daten, variantenId);
      emit('wr_gewaehlt', { iv_wr: variantenId, iv_weg: 'suche' });
      schreibeHash();
      zeichneAlles();
    }

    function uebernimmSpeicherTreffer(wert) {
      var teile = String(wert).split('~');
      if (!UZ.setzeSpeicherTreffer(zustand, daten, teile[0], teile[1])) return;
      emit('speicher_gewaehlt', { iv_speicher: teile[0], iv_groesse: teile[1], iv_weg: 'suche' });
      schreibeHash();
      zeichneAlles();
    }

    /*
     * Suchfeld plus eingeklappte Auswahlfelder. Der Rückfall ist ein
     * <details> — kein zweites Bedienkonzept, sondern derselbe Weg wie bisher,
     * nur eine Umdrehung weiter unten.
     */
    function bauAuswahlBlock(ziel, typ, erlaubt, groessenLabel) {
      bauGeraetesuche(ziel, typ, erlaubt,
        typ === 'wr' ? uebernimmWrTreffer : uebernimmSpeicherTreffer);

      var rueckfall = el('details', 'iv-rueckfall');
      var titel = el('summary', 'iv-rueckfall__titel',
        'Typenbezeichnung nicht zur Hand? Schritt für Schritt wählen');
      rueckfall.appendChild(titel);
      if (zustand.rueckfallOffen[typ]) rueckfall.open = true;
      rueckfall.addEventListener('toggle', function () {
        zustand.rueckfallOffen[typ] = rueckfall.open;
      });
      var felder = el('div', 'iv-felder');
      if (typ === 'wr') bauWrFelder(felder, !!erlaubt);
      else bauSpeicherFelder(felder, groessenLabel);
      rueckfall.appendChild(felder);
      ziel.appendChild(rueckfall);
    }

    function bauWrFelder(ziel, nurFreigegebene) {
      var erlaubt = nurFreigegebene ? freigegebeneWrFuerAuswahl() : null;
      var quelle = erlaubt
        ? daten.wechselrichter.filter(function (f) { return erlaubt.familien[f.id]; })
        : daten.wechselrichter;
      var hersteller = herstellerGruppen(herstellerListe(quelle));
      ziel.appendChild(auswahl('iv-wr-hersteller', 'Hersteller', hersteller, zustand.wrHersteller, function (v) {
        UZ.setzeWrHersteller(zustand, v);
        zeichneAlles();
      }, 'Bitte wählen'));

      var familien = (zustand.wrHersteller ? familienVon(quelle, zustand.wrHersteller) : [])
        .map(function (f) { return mitKlasse(f, findeFamilie(daten.wechselrichter, f.id)); });
      ziel.appendChild(auswahl('iv-wr-familie', 'Modellreihe', familien, zustand.wrFamilie, function (v) {
        UZ.setzeWrFamilie(zustand, v);
        zeichneAlles();
      }, familien.length ? 'Bitte wählen' : 'zuerst Hersteller wählen'));

      var fam = zustand.wrFamilie ? findeFamilie(daten.wechselrichter, zustand.wrFamilie) : null;
      var varianten = fam ? fam.varianten
        .filter(function (v) { return !erlaubt || erlaubt.varianten[v.id]; })
        .map(function (v) {
          return { id: v.id, name: v.name + (istZahl(v.ac_kw) ? ' — ' + kw(v.ac_kw) + ' AC' : '') };
        }) : [];
      ziel.appendChild(auswahl('iv-wr-variante', 'Gerät', varianten, zustand.wrVariante, function (v) {
        UZ.setzeWrVariante(zustand, v);
        if (v) emit('wr_gewaehlt', { iv_wr: v });
        schreibeHash();
        zeichneAlles();
      }, varianten.length ? 'Bitte wählen' : 'zuerst Modellreihe wählen'));
    }

    function bauSpeicherFelder(ziel, groessenLabel) {
      var hersteller = herstellerGruppen(herstellerListe(daten.speicher));
      ziel.appendChild(auswahl('iv-sp-hersteller', 'Hersteller', hersteller, zustand.spHersteller, function (v) {
        UZ.setzeSpHersteller(zustand, v);
        zeichneAlles();
      }, 'Bitte wählen'));

      var familien = (zustand.spHersteller ? familienVon(daten.speicher, zustand.spHersteller) : [])
        .map(function (f) { return mitKlasse(f, findeFamilie(daten.speicher, f.id)); });
      ziel.appendChild(auswahl('iv-sp-familie', 'Modellreihe', familien, zustand.spFamilie, function (v) {
        UZ.setzeSpFamilie(zustand, v);
        zeichneAlles();
      }, familien.length ? 'Bitte wählen' : 'zuerst Hersteller wählen'));

      var fam = zustand.spFamilie ? findeFamilie(daten.speicher, zustand.spFamilie) : null;
      var groessen = fam ? fam.groessen.map(function (g) {
        var kap = engine.kapazitaetKwh(fam, g);
        return { id: g.groesse, name: g.groesse + (istZahl(kap) ? ' — ' + kwh(kap) : '') };
      }) : [];
      ziel.appendChild(auswahl('iv-sp-groesse', groessenLabel || 'Größe', groessen, zustand.spGroesse, function (v) {
        UZ.setzeSpGroesse(zustand, v);
        if (v) emit('speicher_gewaehlt', { iv_speicher: zustand.spFamilie, iv_groesse: v });
        schreibeHash();
        zeichneAlles();
      }, groessen.length ? 'Bitte wählen' : 'zuerst Modellreihe wählen'));
    }

    function zusammenfassungsText() {
      var teile = [];
      if (zustand.aufgabe !== 'wr_finden' && zustand.wrVariante) {
        var wr = null;
        daten.wechselrichter.forEach(function (f) {
          f.varianten.forEach(function (v) { if (v.id === zustand.wrVariante) wr = f.hersteller + ' ' + v.name; });
        });
        if (wr) teile.push(wr);
      }
      if (zustand.aufgabe !== 'speicher_finden' && zustand.spFamilie && zustand.spGroesse) {
        var fam = findeFamilie(daten.speicher, zustand.spFamilie);
        if (fam) teile.push(fam.hersteller + ' ' + fam.name + ' ' + zustand.spGroesse);
      }
      return teile.join('  ·  ');
    }

    /*
     * Fokus in die Auswahl. Nimmt das erste Bedienelement, das dort steht —
     * je nach Aufgabe ist das ein Suchfeld, ein Auswahlfeld oder (bei
     * eingeklappter Auswahl unmittelbar davor) der Knopf „Auswahl ändern".
     * `scrollIntoView` mit `nearest` scrollt nur, wenn es nötig ist; auf dem
     * Handy liegt die Auswahl unter den Reitern, auf dem Desktop meist schon
     * im Bild.
     */
    function fokussiereAuswahl() {
      var ziel = auswahlBereich.querySelector('.iv-suche__feld, .iv-select, .iv-knopf');
      if (!ziel) return;
      if (ziel.scrollIntoView) ziel.scrollIntoView({ block: 'nearest' });
      if (ziel.focus) ziel.focus();
    }

    function zeichneAuswahl() {
      leere(auswahlBereich);
      var aufgabe = aufgabeJetzt();

      // Eingeklappte Zusammenfassung, sobald ein Ergebnis vorliegt
      if (!zustand.auswahlOffen && auswahlVollstaendig()) {
        var leiste = el('div', 'iv-auswahl__kompakt');
        var text = el('p', 'iv-auswahl__kompakt-text');
        text.appendChild(el('span', 'iv-auswahl__kompakt-label', aufgabe.kurz + ':'));
        text.appendChild(el('strong', null, zusammenfassungsText()));
        leiste.appendChild(text);
        leiste.appendChild(knopf('iv-knopf iv-knopf--leise iv-knopf--klein', 'Auswahl ändern', function () {
          zustand.auswahlOffen = true;
          zeichneAlles();
        }));
        auswahlBereich.appendChild(leiste);
        return;
      }

      var karte = el('div', 'iv-panel');
      karte.appendChild(el('h2', 'iv-panel__titel', aufgabe.frage));
      karte.appendChild(el('p', 'iv-panel__hilfe', aufgabe.hilfe));

      var felder = el('div', 'iv-auswahl__block');
      if (zustand.aufgabe === 'speicher_finden') {
        bauAuswahlBlock(felder, 'wr', null);
      } else if (zustand.aufgabe === 'wr_finden') {
        bauAuswahlBlock(felder, 'speicher', null, 'Größe');
      } else {
        bauAuswahlBlock(felder, 'speicher', null, 'Ihre heutige Größe');
      }
      karte.appendChild(felder);

      if (zustand.aufgabe === 'erweitern') {
        var trenn = el('div', 'iv-teilfrage');
        var kopf = el('p', 'iv-teilfrage__titel', 'An welchem Wechselrichter?');
        trenn.appendChild(kopf);
        trenn.appendChild(el('p', 'iv-teilfrage__hilfe',
          'Kompatibilität gilt immer für die Kombination aus beiden Geräten. Deshalb brauchen '
          + 'wir auch Ihren Wechselrichter, um die Frage zu beantworten.'));
        if (!zustand.spFamilie || !zustand.spGroesse) {
          trenn.appendChild(el('p', 'iv-teilfrage__fuss',
            'Bitte wählen Sie zuerst Ihren vorhandenen Speicher. Danach zeigen wir nur die dafür '
            + 'kompatiblen Wechselrichter.'));
        }
        var erlaubt = freigegebeneWrFuerAuswahl();
        /*
         * Erst wenn der Speicher steht, gibt es überhaupt eine Menge, aus der
         * gewählt werden kann. Vorher ein Suchfeld zu zeigen, das zu jeder
         * Eingabe „kein Gerät dieses Namens" antwortet, wäre irreführend — der
         * Hinweis darüber sagt bereits, was zuerst zu tun ist.
         */
        if (erlaubt) {
          var wrFelder = el('div', 'iv-auswahl__block');
          bauAuswahlBlock(wrFelder, 'wr', erlaubt);
          trenn.appendChild(wrFelder);
        }
        if (erlaubt) {
          trenn.appendChild(el('p', 'iv-teilfrage__fuss', erlaubt.anzahl === 0
            ? 'Für diesen Speicher ist in den uns vorliegenden Herstellerlisten kein Wechselrichter '
              + 'bestätigt. Fragen Sie uns, wir prüfen das kostenlos beim Hersteller.'
            : 'Zur Auswahl stehen nur die ' + erlaubt.anzahl + ' Geräte, die für genau diese '
              + 'Speichergröße vom Hersteller bestätigt sind.'));
        }
        karte.appendChild(trenn);
      }

      if (!auswahlVollstaendig()) {
        karte.appendChild(el('p', 'iv-panel__status',
          zustand.aufgabe === 'speicher_finden'
            ? 'Sobald das Gerät gewählt ist, erscheint das Ergebnis automatisch.'
            : (zustand.aufgabe === 'erweitern'
              ? 'Sobald Speicher und Wechselrichter gewählt sind, erscheint das Ergebnis automatisch.'
              : 'Sobald Modellreihe und Größe gewählt sind, erscheint das Ergebnis automatisch.')));
      } else {
        karte.appendChild(knopf('iv-knopf iv-knopf--leise iv-knopf--klein', 'Auswahl einklappen', function () {
          zustand.auswahlOffen = false;
          zeichneAlles();
        }));
      }
      auswahlBereich.appendChild(karte);
    }

    // ----------------------------------------------------------- Ergebnisse --

    function ergebnisDaten() {
      if (zustand.aufgabe === 'speicher_finden') {
        return engine.speicherFuerWr(daten, zustand.wrVariante, 'standard', preise);
      }
      if (zustand.aufgabe === 'wr_finden') {
        return engine.wrFuerSpeicher(daten, zustand.spFamilie, zustand.spGroesse, 'standard', preise);
      }
      return engine.erweiterungFuerSpeicher(daten, zustand.spFamilie, zustand.spGroesse, zustand.wrVariante, preise);
    }

    function aktiveFilterListe(modus) {
      var f = zustand.filter;
      var aktiv = [];
      f.hersteller.forEach(function (h) {
        aktiv.push({ text: h, entfernen: function () { f.hersteller = f.hersteller.filter(function (x) { return x !== h; }); } });
      });
      if (f.leistung !== 'egal') {
        var stufe = LEISTUNGS_STUFEN.filter(function (s) { return s.id === f.leistung; })[0];
        aktiv.push({ text: 'Entladeleistung ' + stufe.name, entfernen: function () { f.leistung = 'egal'; } });
      }
      if (istZahl(f.minKapazitaet)) aktiv.push({ text: 'ab ' + kwh(f.minKapazitaet), entfernen: function () { f.minKapazitaet = null; } });
      if (istZahl(f.maxKapazitaet)) aktiv.push({ text: 'bis ' + kwh(f.maxKapazitaet), entfernen: function () { f.maxKapazitaet = null; } });
      if (istZahl(f.maxEurProKwh)) aktiv.push({ text: 'höchstens ' + euroGenau(f.maxEurProKwh) + ' pro kWh', entfernen: function () { f.maxEurProKwh = null; } });
      if (f.spannungsklasse) {
        aktiv.push({ text: 'nur ' + klasse(f.spannungsklasse).name, entfernen: function () { f.spannungsklasse = null; } });
      }
      if (f.nurVerfuegbar) aktiv.push({ text: 'nur sofort bestellbar', entfernen: function () { f.nurVerfuegbar = false; } });
      if (modus === 'wr') { /* Kapazitätsfilter werden in dieser Richtung nicht angeboten */ }
      return aktiv;
    }

    function engineFilter(modus) {
      return FW.engineFilter(zustand.filter, modus);
    }

    /*
     * Beschreibt die Frage, die der Kunde gestellt hat — Aufgabe plus die
     * getroffene Geräteauswahl. Bewusst OHNE Sortierung und Filter: das sind
     * Blickwinkel auf dieselbe Antwort, keine neue Beratung. Nur so zählt
     * „ergebnis_angezeigt" einmal pro Beratung statt einmal pro Mausklick.
     */
    function ergebnisSignatur() {
      return [
        zustand.aufgabe,
        zustand.wrHersteller, zustand.wrFamilie, zustand.wrVariante,
        zustand.spHersteller, zustand.spFamilie, zustand.spGroesse,
      ].join('|');
    }

    /*
     * Neu zeichnen, ohne dass die Seite springt: Die Scrollposition wird
     * gehalten. Der Aufbau oberhalb der Liste ändert sich dabei nicht, also
     * bleibt der Blick, wo er war.
     */
    function zeichneErgebnisStabil() {
      var vorher = window.pageYOffset;
      zeichneErgebnis();
      window.scrollTo(0, vorher);
    }

    function zeichneErgebnis() {
      leere(ergebnisBereich);
      if (!auswahlVollstaendig()) {
        ergebnisBereich.appendChild(baueEinstiegsHinweis());
        return;
      }
      var ergebnis = ergebnisDaten();
      if (!ergebnis || ergebnis.fehler) {
        ergebnisBereich.appendChild(baueFehler(ergebnis && ergebnis.fehler));
        return;
      }
      if (zustand.aufgabe === 'erweitern') { zeichneErweiterung(ergebnis); return; }

      var modus = zustand.aufgabe === 'speicher_finden' ? 'speicher' : 'wr';
      // Nur herstellerfreigegebene Kombinationen. Unbelegte werden nicht
      // angezeigt und nicht filterbar gemacht — sie wären eine Aussage, die
      // wir nicht belegen können. Der Weg dafür ist die kostenlose Anfrage.
      var basis = ergebnis.freigegeben.slice();
      var gefiltert = engine.filtereErgebnis(basis, engineFilter(modus));
      var sortiert = engine.sortiereNach(gefiltert, zustand.sortierung);

      ergebnisBereich.appendChild(baueErgebnisKopf(ergebnis, modus, sortiert.length, basis.length));
      ergebnisBereich.appendChild(bauePreisHerkunft());
      ergebnisBereich.appendChild(baueWerkzeugleiste(ergebnis, modus, sortiert.length, basis.length));

      if (sortiert.length === 0) {
        ergebnisBereich.appendChild(baueLeerzustand());
      } else {
        var gruppen = gruppiereNachFamilie(sortiert, modus);
        /*
         * Beim ersten Zeichnen die oberste Baureihe öffnen: Man sieht sofort,
         * wie eine Gruppe aussieht, ohne dass neun aufgeklappte Tabellen die
         * Seite fluten. Danach entscheidet die Auswahl des Nutzers.
         */
        if (!zustand.gruppenInitialisiert && gruppen.length) {
          zustand.offeneGruppen = {};
          zustand.offeneGruppen[gruppen[0].schluessel] = true;
          zustand.gruppenInitialisiert = true;
        }
        var liste = el('div', 'iv-familien');
        /*
         * Trennüberschrift vor der zweiten Rangstufe. Sie steht nur in der
         * Voreinstellung, weil nur dort die Rangfolge die Reihenfolge bestimmt —
         * bei eigener Sortierung stünden die Stufen gemischt und eine
         * Überschrift wäre schlicht falsch.
         *
         * Der Text sagt bewusst nichts über Lieferbarkeit: Auch hierunter ist
         * einiges bei inselvolt erhältlich, es sind nur nicht die Marken, mit
         * denen wir uns zeigen.
         */
        gruppen.forEach(function (g, i) {
          /*
           * Trennüberschrift genau da, wo Block 1 endet — und nur, wenn es
           * beide Blöcke gibt. Bei eigener Sortierung des Kunden stehen die
           * Blöcke gemischt, dann wäre eine Überschrift schlicht falsch.
           *
           * Der Zusatz sagt „ohne Shop-Zuordnung", nicht „nicht erhältlich":
           * Die Zuordnung in preise.js ist kuratiert, ein fehlender Eintrag
           * ist keine Aussage über das Sortiment. Genau dieselbe Zurückhaltung
           * wie bei „Preis auf Anfrage" an der einzelnen Zeile.
           */
          if (zustand.sortierung === 'empfehlung'
              && i === zustand.trennerAb && i > 0 && i < gruppen.length) {
            var trenner = el('h3', 'iv-familien__trenner');
            trenner.appendChild(el('span', null, 'Weitere vom Hersteller freigegebene Baureihen'));
            // Leerzeichen als eigener Knoten: Der Abstand kommt optisch aus dem
            // Flex-Gap, im vorgelesenen Text gäbe es ihn sonst nicht.
            trenner.appendChild(document.createTextNode(' '));
            trenner.appendChild(el('span', 'iv-familien__trenner-zusatz',
              'Diese führen wir nicht im Shop. Preis auf Anfrage.'));
            liste.appendChild(trenner);
          }
          liste.appendChild(baueFamilienGruppe(g, modus, ergebnis, i));
        });
        ergebnisBereich.appendChild(liste);
      }

      /*
       * Nur in der Wechselrichter-Richtung: Dort sucht der Kunde ein Gerät, und
       * dort ist ein vom Hersteller freigegebenes, uns aber unbekanntes Gerät
       * die Auskunft, die ihm sonst niemand gibt. In der Speicher-Richtung wäre
       * derselbe Hinweis bloß Rauschen.
       */
      if (modus === 'wr') {
        var offeneKiste = baueOffeneGeraete(ergebnis);
        if (offeneKiste) ergebnisBereich.appendChild(offeneKiste);
      }

      ergebnisBereich.appendChild(baueVergleichsLeiste(modus, ergebnis));
      ergebnisBereich.appendChild(baueFussnote(ergebnis));
      ergebnisBereich.appendChild(baueAnfrageBlock());
      emitEinmalig('ergebnis_angezeigt', ergebnisSignatur(), {
        iv_aufgabe: zustand.aufgabe, iv_treffer: sortiert.length, iv_freigegeben: ergebnis.freigegeben.length,
      });
    }

    /*
     * Herkunft der Preise — im Notbetrieb bewusst auffällig. Der Kunde muss
     * erkennen können, ob er einen Live-Preis oder einen datierten Stand sieht.
     */
    function bauePreisHerkunft() {
      var box = el('div', 'iv-preisquelle');
      box.appendChild(el('span', 'iv-preisquelle__punkt'));
      var a = PS.anzeige(preisHerkunft);
      if (a.art === 'live') box.className += ' iv-preisquelle--live';
      if (a.art === 'rueckfall') box.className += ' iv-preisquelle--datei';
      box.appendChild(el('span', null, a.text));
      return box;
    }

    /*
     * „Der Hersteller nennt noch ein Gerät, das wir nicht führen."
     *
     * Ohne diesen Kasten wäre die Ergebnisliste einfach eine Zeile kürzer, und
     * niemand könnte das bemerken — genau so fiel der SMILE-G3-T5 acht Wochen
     * lang durch. Gezeigt wird er nur in der Wechselrichter-Richtung: Dort
     * sucht der Kunde ein Gerät, und dort kostet das Fehlen ihn etwas.
     *
     * Keine Leistungsangabe, keine Rechnung, kein Ranking — zum Gerät liegt uns
     * kein Datenblatt vor. Nur die Quelle, das Datum und der Weg zur Anfrage.
     */
    function baueOffeneGeraete(ergebnis) {
      var offen = engine.offeneGeraeteFuerSpeicher(daten, ergebnis.speicher.id);
      if (!offen.length) return null;

      var box = el('div', 'iv-hinweisbox iv-hinweisbox--offen');
      box.appendChild(el('h3', null, offen.length === 1
        ? 'Ein weiteres Gerät ist freigegeben, liegt uns aber noch nicht vor'
        : offen.length + ' weitere Geräte sind freigegeben, liegen uns aber noch nicht vor'));

      var ul = el('ul', 'iv-offen__liste');
      offen.forEach(function (g) {
        var li = el('li');
        li.appendChild(el('strong', null, g.name));
        li.appendChild(document.createTextNode(
          ' — laut Hersteller mit diesem Speicher freigegeben, technische Daten liegen uns '
          + 'noch nicht vor.' + (g.grund ? ' ' + g.grund : '')));
        var q = daten.quellen[g.quelle];
        if (q) {
          li.appendChild(el('span', 'iv-offen__quelle',
            ' Quelle: ' + q.titel + (q.stand ? ', ' + q.stand : '')
            + (q.abruf_datum ? ' (abgerufen ' + datumLang(q.abruf_datum) + ')' : '')));
        }
        ul.appendChild(li);
      });
      box.appendChild(ul);
      box.appendChild(el('p', 'iv-offen__fuss',
        'Ohne Datenblatt nennen wir keine Lade- und Entladeleistung — geschätzt wird hier nichts.'));
      box.appendChild(kontaktLink('Diese Kombination kostenlos prüfen lassen', 'iv-knopf iv-knopf--leise'));
      return box;
    }

    function baueEinstiegsHinweis() {
      var box = el('div', 'iv-hinweisbox');
      box.appendChild(el('p', null, 'Treffen Sie oben Ihre Auswahl. Ihr Ergebnis erscheint dann hier.'));
      return box;
    }

    function baueFehler(code) {
      var box = el('div', 'iv-hinweisbox');
      box.appendChild(el('h3', null, 'Diese Auswahl kennen wir nicht'));
      box.appendChild(el('p', null, code === 'groesse_unbekannt'
        ? 'Zu dieser Größe liegt uns kein Datensatz vor.'
        : 'Zu diesem Gerät liegt uns kein Datensatz vor.'));
      box.appendChild(kontaktLink('Kompatibilität kostenlos prüfen lassen', 'iv-knopf iv-knopf--primaer'));
      return box;
    }

    function baueErgebnisKopf(ergebnis, modus, gezeigt, gesamt) {
      var kopf = el('div', 'iv-ergebnis__kopf');
      var bezug = modus === 'speicher'
        ? ergebnis.wr.hersteller + ' ' + ergebnis.wr.name
        : ergebnis.speicher.hersteller + ' ' + ergebnis.speicher.name + ' ' + ergebnis.speicher.groesse;
      var anzahl = ergebnis.freigegeben.length;
      var baureihen = gruppiereNachFamilie(ergebnis.freigegeben, modus).length;
      kopf.appendChild(el('h2', 'iv-ergebnis__titel',
        baureihen + (baureihen === 1 ? ' kompatible Baureihe' : ' kompatible Baureihen')));
      var p = el('p', 'iv-ergebnis__unter');
      p.appendChild(el('b', null, String(anzahl)));
      p.appendChild(document.createTextNode(modus === 'speicher'
        ? (anzahl === 1 ? ' Speichergröße ist ' : ' Speichergrößen sind ')
        : (anzahl === 1 ? ' Gerät ist ' : ' Geräte sind ')));
      /* „sind vom Hersteller für X kompatibel" ist kein Deutsch — das Adjektiv
       * verträgt den Urheber nicht. Also das Partizip, das ihn verträgt: Das
       * Kundenwort steht in der Überschrift („7 kompatible Baureihen"), die
       * Herkunft in diesem Satz. */
      p.appendChild(document.createTextNode('vom Hersteller für '));
      p.appendChild(el('b', null, bezug));
      p.appendChild(document.createTextNode(' bestätigt. Ihre Wunschkombination ist nicht dabei? '
        + 'Wir prüfen sie kostenlos beim Hersteller.'));
      kopf.appendChild(p);
      return kopf;
    }

    function baueWerkzeugleiste(ergebnis, modus, gezeigt, gesamt) {
      var huelle = el('div', 'iv-werkzeuge');

      var zeile = el('div', 'iv-werkzeuge__zeile');
      var anzahlAktiv = aktiveFilterListe(modus).length;
      /*
       * Der Filter ist das wichtigste Werkzeug über der Liste und war als leiser
       * Textknopf schlicht übersehbar. Jetzt: eigenständige, kräftige Schaltfläche;
       * die Zahl aktiver Filter sitzt als Punkt daran, damit ein zugeklapptes
       * Panel nie versteckt, DASS gefiltert wird.
       */
      var filterKnopf = knopf('iv-filter-knopf' + (zustand.filterOffen ? ' iv-filter-knopf--offen' : ''), null,
        function () { zustand.filterOffen = !zustand.filterOffen; zeichneAlles(); });
      filterKnopf.appendChild(icon('filter'));
      filterKnopf.appendChild(el('span', null, 'Filtern & Eingrenzen'));
      if (anzahlAktiv) filterKnopf.appendChild(el('span', 'iv-filter-knopf__zahl', String(anzahlAktiv)));
      filterKnopf.setAttribute('aria-expanded', zustand.filterOffen ? 'true' : 'false');
      zeile.appendChild(filterKnopf);

      var sortHuelle = el('label', 'iv-sortierung');
      sortHuelle.appendChild(el('span', 'iv-sortierung__label', 'Sortieren nach'));
      var sel = el('select', 'iv-select iv-select--klein');
      var optionen = SORTIER_OPTIONEN[modus].slice();
      // Über einen Spaltenkopf kann eine Richtung gewählt werden, die hier nicht
      // als Voreinstellung steht — dann wird sie ergänzt, damit das Feld zeigt,
      // wonach tatsächlich sortiert ist.
      var bekannt = optionen.some(function (o) { return o.id === zustand.sortierung; });
      if (!bekannt && SORTIER_NAMEN[zustand.sortierung]) {
        optionen.splice(1, 0, { id: zustand.sortierung, name: SORTIER_NAMEN[zustand.sortierung] });
      }
      optionen.forEach(function (o) {
        var opt = el('option', null, o.name);
        opt.value = o.id;
        if (o.id === zustand.sortierung) opt.selected = true;
        sel.appendChild(opt);
      });
      sel.addEventListener('change', function () {
        zustand.sortierung = sel.value;
        emit('sortierung_gewaehlt', { iv_sortierung: sel.value });
        zeichneErgebnisStabil();
      });
      sortHuelle.appendChild(sel);
      // (i) an die Beschriftung, nicht daneben — sonst rutscht sie auf schmalen
      // Schirmen in eine eigene Zeile und steht dort ohne Bezug.
      sortHuelle.insertBefore(
        hilfe('Sortiert wird über die Baureihen hinweg: Jede Baureihe rückt so weit nach vorn, '
          + 'wie es ihre beste Variante verdient. Innerhalb einer Baureihe stehen die Größen '
          + 'immer aufsteigend, wie im Datenblatt.'),
        sel);
      zeile.appendChild(sortHuelle);

      var zaehler = el('p', 'iv-zaehler', gezeigt === gesamt
        ? gezeigt + (modus === 'speicher' ? ' Größen' : ' Geräte')
        : gezeigt + ' von ' + gesamt + (modus === 'speicher' ? ' Größen' : ' Geräten'));
      zeile.appendChild(zaehler);

      huelle.appendChild(zeile);

      if (zustand.filterOffen) huelle.appendChild(baueFilterPanel(ergebnis, modus));

      var aktiv = aktiveFilterListe(modus);
      if (aktiv.length) {
        var chips = el('div', 'iv-aktivfilter');
        chips.appendChild(el('span', 'iv-aktivfilter__label', 'Aktive Filter:'));
        aktiv.forEach(function (a) {
          var c = knopf('iv-chip iv-chip--entfernbar', a.text, function () { a.entfernen(); zeichneAlles(); });
          c.setAttribute('aria-label', 'Filter entfernen: ' + a.text);
          c.appendChild(el('span', 'iv-chip__x', '×'));
          chips.appendChild(c);
        });
        chips.appendChild(knopf('iv-textknopf', 'Alle zurücksetzen', function () {
          zustand.filter = FW.neuerFilter();
          zeichneAlles();
        }));
        huelle.appendChild(chips);
      }

      /*
       * Export bewusst abgesetzt: Er verändert das Ergebnis nicht, sondern
       * nimmt es mit. Zwischen Filtern gestellt, wirkte er wie eine weitere
       * Einstellung — hier ist erkennbar, dass er etwas anderes tut.
       */
      var export_ = el('div', 'iv-export');
      var exportKnopf = knopf('iv-knopf iv-knopf--leise iv-knopf--klein', null, function () {
        drucke(ergebnis, modus);
      });
      exportKnopf.appendChild(icon('pdf'));
      exportKnopf.appendChild(el('span', null, 'Als PDF speichern'));
      export_.appendChild(exportKnopf);
      export_.appendChild(el('span', 'iv-export__text', 'Ergebnis zum Mitnehmen oder für den Elektrobetrieb'));
      export_.appendChild(hilfe('Öffnet den Druckdialog Ihres Browsers. Dort „Als PDF sichern" wählen. '
        + 'Ausgegeben wird die aktuelle Auswahl mit allen Kennzahlen, den Auflagen des Herstellers und den '
        + 'Quellen. Ideal zum Weitergeben an Ihren Elektrobetrieb.'));
      huelle.appendChild(export_);
      return huelle;
    }

    /*
     * Facetten: Ein Filter, der nichts findet, ist kein Filter — er ist eine
     * Sackgasse. Deshalb wird jede Auswahlmöglichkeit gegen den TATSÄCHLICHEN
     * Ergebnisbestand gezählt und nur angeboten, wenn sie zu Treffern führt.
     * Gezählt wird jeweils mit allen ANDEREN aktiven Filtern, aber ohne den
     * gerade betrachteten — sonst würde die Auswahl eines Herstellers alle
     * übrigen Hersteller aus der Liste werfen.
     */
    function zaehleMit(basis, modus, aenderung) {
      return FW.zaehleMit(engine, basis, modus, zustand.filter, aenderung);
    }

    function baueFilterPanel(ergebnis, modus) {
      var panel = el('div', 'iv-filter');
      var basis = ergebnis.freigegeben.slice();

      // ---- Hersteller: nur die, die im Ergebnis vorkommen, mit Trefferzahl ----
      var herstellerImErgebnis = FW.herstellerFacette(engine, basis, modus, zustand.filter);

      if (herstellerImErgebnis.length > 1) {
        var gruppeH = el('fieldset', 'iv-filter__gruppe');
        gruppeH.appendChild(el('legend', 'iv-filter__titel', 'Hersteller'));
        var chipsH = el('div', 'iv-chips');
        herstellerImErgebnis.forEach(function (h) {
          var an = zustand.filter.hersteller.indexOf(h.name) !== -1;
          var c = knopf('iv-chip' + (an ? ' iv-chip--an' : ''), h.name, function () {
            if (an) zustand.filter.hersteller = zustand.filter.hersteller.filter(function (x) { return x !== h.name; });
            else zustand.filter.hersteller = zustand.filter.hersteller.concat([h.name]);
            zeichneAlles();
          });
          c.appendChild(el('span', 'iv-chip__zahl', String(h.treffer)));
          c.setAttribute('aria-pressed', an ? 'true' : 'false');
          chipsH.appendChild(c);
        });
        gruppeH.appendChild(chipsH);
        panel.appendChild(gruppeH);
      }

      // ---- Spannungsklasse: nur anbieten, wenn beide Welten im Ergebnis stecken ----
      var klassen = FW.spannungsklassenImErgebnis(basis);
      if (klassen.length > 1 || zustand.filter.spannungsklasse) {
        var gruppeK2 = el('fieldset', 'iv-filter__gruppe');
        var legende = el('legend', 'iv-filter__titel');
        legende.appendChild(el('span', null, 'Spannungsklasse'));
        legende.appendChild(hilfe(KLASSEN.hochvolt.erklaerung + ' ' + KLASSEN.niedervolt.erklaerung));
        gruppeK2.appendChild(legende);
        var chipsK2 = el('div', 'iv-chips');
        [null].concat(klassen).forEach(function (k) {
          var an = zustand.filter.spannungsklasse === k;
          var treffer = zaehleMit(basis, modus, { spannungsklasse: k });
          if (k !== null && treffer === 0 && !an) return;
          var c = knopf('iv-chip' + (an ? ' iv-chip--an' : ''), k === null ? 'Alle' : klasse(k).name, function () {
            zustand.filter.spannungsklasse = k;
            zeichneAlles();
          });
          c.appendChild(el('span', 'iv-chip__zahl', String(treffer)));
          c.setAttribute('aria-pressed', an ? 'true' : 'false');
          chipsK2.appendChild(c);
        });
        gruppeK2.appendChild(chipsK2);
        panel.appendChild(gruppeK2);
      }

      // ---- Entladeleistung: nur Stufen, die zu Treffern führen ----
      /*
       * Eine Stufe, die genauso viele Treffer liefert wie „Alle", grenzt nichts
       * ein — sie sieht nur nach Auswahl aus. Solche Stufen fliegen ebenso raus
       * wie leere. Die aktive Stufe bleibt immer stehen, damit die eigene
       * Auswahl nicht unter den Fingern verschwindet.
       */
      var stufen = FW.leistungsFacette(engine, basis, modus, zustand.filter).stufen;

      if (stufen.length > 1) {
        var gruppeL = el('fieldset', 'iv-filter__gruppe');
        gruppeL.appendChild(el('legend', 'iv-filter__titel', 'Mindest-Entladeleistung'));
        gruppeL.appendChild(el('p', 'iv-filter__hilfe',
          'Wie viel Leistung soll gleichzeitig bereitstehen? Kombinationen ohne belegten Wert bleiben sichtbar.'));
        var chipsL = el('div', 'iv-chips');
        stufen.forEach(function (x) {
          var an = zustand.filter.leistung === x.stufe.id;
          var c = knopf('iv-chip' + (an ? ' iv-chip--an' : ''), x.stufe.name, function () {
            zustand.filter.leistung = x.stufe.id;
            emit('leistungsfilter_gewaehlt', { iv_leistung: x.stufe.id });
            zeichneAlles();
          });
          c.appendChild(el('span', 'iv-chip__zahl', String(x.treffer)));
          c.title = x.stufe.titel;
          c.setAttribute('aria-pressed', an ? 'true' : 'false');
          chipsL.appendChild(c);
        });
        gruppeL.appendChild(chipsL);
        panel.appendChild(gruppeL);
      }

      if (modus === 'speicher') {
        // ---- Kapazität: Grenzen aus den vorhandenen Werten, nicht geraten ----
        var kap = FW.kapazitaetsSpanne(basis);
        var kapMin = kap ? kap.min : null;
        var kapMax = kap ? kap.max : null;
        if (kap && kap.anzahl > 1 && kapMin !== kapMax) {
          var gruppeK = el('fieldset', 'iv-filter__gruppe');
          gruppeK.appendChild(el('legend', 'iv-filter__titel', 'Nutzbare Kapazität'));
          gruppeK.appendChild(el('p', 'iv-filter__hilfe', 'Im Ergebnis vorhanden: ' + kwh(kapMin) + ' bis ' + kwh(kapMax) + '.'));
          var zeileK = el('div', 'iv-filter__zeile');
          zeileK.appendChild(zahlenFeld('iv-f-kapmin', 'von (kWh)', zustand.filter.minKapazitaet,
            Math.floor(kapMin), function (v) { zustand.filter.minKapazitaet = v; zeichneAlles(); }));
          zeileK.appendChild(zahlenFeld('iv-f-kapmax', 'bis (kWh)', zustand.filter.maxKapazitaet,
            Math.ceil(kapMax), function (v) { zustand.filter.maxKapazitaet = v; zeichneAlles(); }));
          gruppeK.appendChild(zeileK);
          panel.appendChild(gruppeK);
        }

        // ---- Preis pro kWh: nur anbieten, wenn es überhaupt Preise gibt ----
        var proKwh = FW.preisProKwhSpanne(basis);
        if (proKwh && proKwh.anzahl > 1) {
          var pMin = proKwh.min;
          var pMax = proKwh.max;
          if (pMin !== pMax) {
            var gruppeP = el('fieldset', 'iv-filter__gruppe');
            gruppeP.appendChild(el('legend', 'iv-filter__titel', 'Preis pro kWh'));
            gruppeP.appendChild(el('p', 'iv-filter__hilfe',
              'Speicherpreis geteilt durch nutzbare Kapazität. Im Ergebnis: '
              + euroGenau(pMin) + ' bis ' + euroGenau(pMax) + '.'));
            var zeileP = el('div', 'iv-filter__zeile');
            zeileP.appendChild(zahlenFeld('iv-f-eurkwh', 'höchstens (€/kWh)', zustand.filter.maxEurProKwh,
              Math.ceil(pMax), function (v) { zustand.filter.maxEurProKwh = v; zeichneAlles(); }));
            gruppeP.appendChild(zeileP);
            panel.appendChild(gruppeP);
          }
        }
      }

      // ---- Anzeige-Schalter: nur, wenn sie etwas bewirken können ----
      var gruppeS = el('fieldset', 'iv-filter__gruppe');
      var schalterVorhanden = false;
      gruppeS.appendChild(el('legend', 'iv-filter__titel', 'Anzeige'));

      var lieferbar = zaehleMit(basis, modus, { nur_verfuegbar: true });
      if (lieferbar > 0 && lieferbar < basis.length) {
        gruppeS.appendChild(schalter('iv-f-verfuegbar',
          'Nur sofort bestellbare zeigen (' + lieferbar + ')', zustand.filter.nurVerfuegbar, function (an) {
            zustand.filter.nurVerfuegbar = an; zeichneAlles();
          }));
        schalterVorhanden = true;
      }
      if (schalterVorhanden) panel.appendChild(gruppeS);

      if (!panel.firstChild) {
        panel.appendChild(el('p', 'iv-filter__leer',
          'Für dieses Ergebnis gibt es nichts zu filtern.'));
      }
      return panel;
    }

    function zahlenFeld(id, beschriftung, wert, platzhalter, beiAenderung) {
      var huelle = el('div', 'iv-feld iv-feld--klein');
      var lab = el('label', 'iv-feld__label', beschriftung);
      lab.setAttribute('for', id);
      var input = el('input', 'iv-input');
      input.type = 'number';
      input.id = id;
      input.min = '0';
      input.step = '0.1';
      input.inputMode = 'decimal';
      if (istZahl(wert)) input.value = String(wert);
      if (platzhalter) input.placeholder = String(platzhalter);
      input.addEventListener('change', function () {
        var v = parseFloat(input.value.replace(',', '.'));
        beiAenderung(isFinite(v) ? v : null);
      });
      huelle.appendChild(lab);
      huelle.appendChild(input);
      return huelle;
    }

    function schalter(id, beschriftung, an, beiAenderung) {
      var lab = el('label', 'iv-schalter');
      var box = el('input');
      box.type = 'checkbox';
      box.id = id;
      box.checked = !!an;
      box.addEventListener('change', function () { beiAenderung(box.checked); });
      lab.appendChild(box);
      lab.appendChild(el('span', null, beschriftung));
      return lab;
    }

    // -------------------------------------------------- Baureihen-Gruppen ----

    /*
     * Gruppierung, Kachel und Varianten-Tabelle stehen seit 2026-08-15 in
     * app/familien.js — dieselbe Darstellung benutzt das Produktseiten-Overlay.
     * Hier bleibt nur die Verdrahtung mit dem Zustand DIESER Seite: welche
     * Gruppe offen ist, welche Sortierung gilt, was der Vergleich aufnimmt und
     * was „Details" öffnet. Genau das kennt das Modul bewusst nicht.
     */
    var schluesselVon = F.schluesselVon;
    var leistungsText = F.leistungsText;

    function gruppiereNachFamilie(sortiert, modus) {
      var gruppiert = F.gruppiere(sortiert, modus, { sortierung: zustand.sortierung });
      /* Für die Trennüberschrift: ab hier beginnt Block 2 (Baureihen ohne
       * Shop-Zuordnung). Ohne Voreinstellung gibt es keine zwei Blöcke. */
      zustand.trennerAb = gruppiert.trennerAb;
      return gruppiert.gruppen;
    }

    function baueFamilienGruppe(gruppe, modus, ergebnis) {
      return F.kachel(gruppe, modus, {
        offen: !!zustand.offeneGruppen[gruppe.schluessel],
        aufWechsel: function (schluessel, offen) {
          zustand.offeneGruppen[schluessel] = offen;
          zustand.gruppenInitialisiert = true;
        },
        sortierung: zustand.sortierung,
        aufSortierung: function (neu) {
          zustand.sortierung = neu;
          emit('sortierung_gewaehlt', { iv_sortierung: neu, iv_ueber: 'spaltenkopf' });
          zeichneErgebnisStabil();
        },
        vergleich: {
          ausgewaehlt: zustand.vergleich,
          /*
           * Die Obergrenze prüft der Aufrufer, nicht das Modul: Nur hier steht
           * der laufende Stand. Ein `false` lehnt die Wahl ab, das Häkchen
           * springt zurück.
           */
          aufWechsel: function (id, an) {
            if (!UZ.vergleichWechsel(zustand, id, an, MAX_VERGLEICH)) return false;
            fuelleVergleichsLeiste(modus, ergebnis);
            return true;
          },
        },
        aufDetail: function (e) { zeigeDetail(e, modus, ergebnis); },
        aufProdukt: function (e, handle) {
          emit('lead_klick', { iv_ziel: 'produkt', iv_handle: handle });
        },
      });
    }


    function baueLeerzustand() {
      var box = el('div', 'iv-hinweisbox');
      box.appendChild(el('h3', null, 'Keine Kombination passt zu diesen Filtern'));
      box.appendChild(el('p', null,
        'Lockern Sie einen Filter. Am häufigsten schränkt die Mindest-Entladeleistung oder der Preis pro kWh zu stark ein. '
        + 'Oder lassen Sie uns die gewünschte Kombination kostenlos beim Hersteller prüfen.'));
      var reihe = el('div', 'iv-knopfreihe');
      reihe.appendChild(knopf('iv-knopf iv-knopf--leise', 'Filter zurücksetzen', function () {
        zustand.filter = {
          hersteller: [], leistung: 'egal', minKapazitaet: null, maxKapazitaet: null,
          maxEurProKwh: null, nurVerfuegbar: false, spannungsklasse: null,
        };
        zeichneAlles();
      }));
      reihe.appendChild(kontaktLink('Kombination prüfen lassen', 'iv-knopf iv-knopf--primaer'));
      box.appendChild(reihe);
      return box;
    }

    function baueFussnote(ergebnis) {
      var p = el('p', 'iv-fussnote');
      p.textContent = 'Preise sind Richtwerte aus dem inselvolt-Shop. Maßgeblich ist der Preis '
        + 'im Shop zum Bestellzeitpunkt. „bis x kW" heißt: Für diese Rechnung fehlt noch ein '
        + 'Datenblattwert, mehr als die Obergrenze kann die Kombination aber nicht.';
      return p;
    }

    function baueAnfrageBlock() {
      var box = el('div', 'iv-anfrage');
      box.appendChild(el('p', null,
        'Ihre Kombination ist nicht dabei oder Sie sind unsicher? Wir prüfen die Kompatibilität kostenlos '
        + 'beim Hersteller und antworten mit Beleg.'));
      var anfrage = kontaktLink('Kompatibilität anfragen', 'iv-knopf iv-knopf--primaer');
      anfrage.addEventListener('click', function () { emit('lead_klick', { iv_ziel: 'anfrage' }); });
      box.appendChild(anfrage);
      return box;
    }

    // -------------------------------------------------------- Erweiterung ----

    function zeichneErweiterung(e) {
      /*
       * Auch hier nur Belegtes: Eine größere Stufe, die für diesen
       * Wechselrichter nicht freigegeben ist, wäre keine Option, sondern ein
       * Vorschlag ins Blaue. Sie fällt heraus; die Zahl bleibt aber sichtbar,
       * damit erkennbar ist, dass die Baureihe weiterginge.
       */
      var alleStufen = e.stufen;
      var stufen = alleStufen.filter(function (s) { return s.status === 'freigegeben'; });
      var kopf = el('div', 'iv-ergebnis__kopf');
      kopf.appendChild(el('h2', 'iv-ergebnis__titel', stufen.length === 0
        ? (alleStufen.length === 0
          ? 'Ihr Speicher ist bereits die größte Stufe dieser Baureihe'
          : 'Keine größere Ausbaustufe ist für diese Kombination bestätigt')
        : stufen.length + (stufen.length === 1 ? ' kompatible Ausbaustufe' : ' kompatible Ausbaustufen')));
      var unter = el('p', 'iv-ergebnis__unter');
      if (e.wr) {
        unter.appendChild(document.createTextNode('Geprüft für '));
        unter.appendChild(el('b', null, e.speicher.hersteller + ' ' + e.speicher.name + ' ' + e.ist.groesse
          + ' am ' + e.wr.hersteller + ' ' + e.wr.name));
        unter.appendChild(document.createTextNode('.'));
      }
      kopf.appendChild(unter);
      ergebnisBereich.appendChild(kopf);

      // Ist-Zustand
      var ist = el('div', 'iv-ist');
      ist.appendChild(el('p', 'iv-ist__label', 'Ihr Speicher heute'));
      var istZeile = el('dl', 'iv-kennzahlen iv-kennzahlen--breit');
      function istWert(label, wert) {
        var d = el('div', 'iv-kennzahl');
        var dd = el('dd', null, wert || FEHLT);
        if (!wert) dd.className = 'iv-kennzahl--offen';
        d.appendChild(dd);
        d.appendChild(el('dt', null, label));
        istZeile.appendChild(d);
      }
      istWert('Größe', e.ist.groesse + (istZahl(e.ist.module) ? ' (' + e.ist.module + ' Module)' : ''));
      istWert('Kapazität', kwh(e.ist.kapazitaet_kwh));
      istWert('Entladen', leistungsText(e.ist.kombi && e.ist.kombi.entladen));
      istWert('Laden', leistungsText(e.ist.kombi && e.ist.kombi.laden));
      ist.appendChild(istZeile);
      if (e.wr_deckelt_leistung) {
        ist.appendChild(el('p', 'iv-ist__merke',
          'Schon heute begrenzt Ihr Wechselrichter die Entladeleistung. Zusätzliche Module '
          + 'vergrößern Ihren Stromvorrat, die Leistung bleibt gleich.'));
      }
      ergebnisBereich.appendChild(ist);

      if (stufen.length) {
        var liste = el('div', 'iv-stufen');
        stufen.forEach(function (st) { liste.appendChild(baueStufenKarte(st, e)); });
        ergebnisBereich.appendChild(liste);
      } else {
        var box = el('div', 'iv-hinweisbox');
        if (alleStufen.length === 0) {
          box.appendChild(el('h3', null, 'Ihr Turm ist bereits voll ausgebaut'));
          box.appendChild(el('p', null,
            'Diese Baureihe endet bei Ihrer Größe. Mehr Kapazität erreichen Sie mit einem zweiten Turm '
            + 'oder einem zusätzlichen Speicher samt eigenem Wechselrichter. Die Hinweise unten helfen '
            + 'bei der Einordnung, und wir beraten Sie gerne persönlich.'));
        } else {
          box.appendChild(el('h3', null, 'Für Ihren Wechselrichter ist keine größere Stufe bestätigt'));
          box.appendChild(el('p', null,
            'Die Baureihe kennt ' + alleStufen.length + ' größere ' + (alleStufen.length === 1 ? 'Stufe' : 'Stufen')
            + '. In den Herstellerlisten, die uns vorliegen, ist davon keine für Ihren Wechselrichter '
            + 'aufgeführt. Das muss nichts heißen: Wir fragen kostenlos beim Hersteller nach und '
            + 'antworten Ihnen mit Beleg.'));
        }
        ergebnisBereich.appendChild(box);
      }

      /*
       * Verweis auf den Rentabilitätsrechner genau hier, weil er exakt diese
       * Frage beantwortet: Lohnt sich die zusätzliche Kapazität für meinen
       * Verbrauch? Der Berater sagt, WAS technisch freigegeben ist; der
       * Rechner sagt, ob es sich rechnet. Die App ergänzt den Blick nach dem
       * Kauf. Beides sind inselvolt-Seiten, keine Fremdwerbung.
       */
      var rechner = el('div', 'iv-callout');
      var rechnerText = el('div', 'iv-callout__text');
      rechnerText.appendChild(el('h3', null, 'Lohnt sich die Erweiterung für Sie?'));
      rechnerText.appendChild(el('p', null,
        'Unser Rentabilitätsrechner zeigt Ihnen in zwei Minuten, wie sich zusätzliche '
        + 'Kilowattstunden auf Autarkie, Eigenverbrauch und Amortisation auswirken.'));
      var rechnerLink = shopLink('https://www.inselvolt.de/pages/rentabilitaetsrechner-speichererweiterung',
        'Rentabilität berechnen', 'iv-knopf iv-knopf--primaer iv-knopf--klein');
      rechnerLink.addEventListener('click', function () { emit('lead_klick', { iv_ziel: 'rentabilitaetsrechner' }); });
      var rechnerApp = el('p', 'iv-callout__neben');
      rechnerApp.appendChild(document.createTextNode('Schon inselvolt-Kunde? Die '));
      var appLink = shopLink('https://kundenapp.inselvolt.de/', 'inselvolt App', 'iv-textlink');
      appLink.addEventListener('click', function () { emit('lead_klick', { iv_ziel: 'kundenapp' }); });
      rechnerApp.appendChild(appLink);
      rechnerApp.appendChild(document.createTextNode(
        ' zeigt Ihnen live, wann Strom günstig ist und wie viel Ihre Anlage wirklich bringt.'));
      rechner.appendChild(rechnerText);
      var rechnerAktionen = el('div', 'iv-callout__aktionen');
      rechnerAktionen.appendChild(rechnerLink);
      rechnerAktionen.appendChild(rechnerApp);
      rechner.appendChild(rechnerAktionen);
      ergebnisBereich.appendChild(rechner);

      ergebnisBereich.appendChild(bauePraxisHinweise());
      ergebnisBereich.appendChild(baueFussnote(e));
      ergebnisBereich.appendChild(baueAnfrageBlock());
      emitEinmalig('ergebnis_angezeigt', ergebnisSignatur(), { iv_aufgabe: 'erweitern', iv_stufen: alleStufen.length, iv_freigegeben: stufen.length });
    }

    function baueStufenKarte(stufe, e) {
      var karte = el('article', 'iv-stufe iv-stufe--frei');

      /*
       * Die Karte beantwortet die Erweiterungs-Frage in der Reihenfolge, in der
       * Kunden sie stellen: Wie viele Module brauche ich? Was habe ich danach
       * (absolut, nicht nur als Zugewinn)? Was kostet das Nachrüsten? Der Link
       * führt deshalb aufs Erweiterungsmodul, nicht auf einen zweiten
       * Komplettspeicher.
       */
      var kopf = el('div', 'iv-stufe__kopf');
      var titel = el('div');
      titel.appendChild(el('h3', 'iv-stufe__titel', stufe.bezeichnung || (e.speicher.name + ' ' + stufe.groesse)));
      var meta = kwh(stufe.kapazitaet_kwh) || 'Kapazität folgt';
      if (istZahl(stufe.module)) meta += '  ·  ' + stufe.module + ' Module gesamt';
      titel.appendChild(el('p', 'iv-stufe__meta', meta));
      kopf.appendChild(titel);
      if (istZahl(stufe.delta_module) && stufe.delta_module > 0) {
        var badge = el('span', 'iv-stufe__badge');
        badge.appendChild(el('b', null, '+' + stufe.delta_module));
        badge.appendChild(el('span', null, stufe.delta_module === 1 ? 'Modul' : 'Module'));
        badge.title = 'So viele Module rüsten Sie nach';
        kopf.appendChild(badge);
      }
      karte.appendChild(kopf);

      /*
       * Vorher und nachher als absolute Werte: „+1,92 kW" allein sagt dem
       * Kunden nicht, wo er landet. Jede Spalte zeigt heute, danach und den
       * Zugewinn, damit die Entscheidung ohne Kopfrechnen fällt.
       */
      var werte = el('div', 'iv-stufe__werte');
      function wertSpalte(label, alt, neu, deltaText) {
        var sp = el('div', 'iv-wert');
        sp.appendChild(el('span', 'iv-wert__label', label));
        var zeile = el('div', 'iv-wert__zeile');
        zeile.appendChild(el('span', 'iv-wert__alt', alt || FEHLT));
        zeile.appendChild(el('span', 'iv-wert__pfeil', '→'));
        zeile.appendChild(el('b', 'iv-wert__neu', neu || FEHLT));
        sp.appendChild(zeile);
        if (deltaText) sp.appendChild(el('span', 'iv-wert__delta', deltaText));
        werte.appendChild(sp);
      }
      wertSpalte('Kapazität',
        kwh(e.ist.kapazitaet_kwh), kwh(stufe.kapazitaet_kwh),
        istZahl(stufe.delta_kwh) ? '+ ' + kwh(stufe.delta_kwh) : null);
      wertSpalte('Entladen',
        leistungsText(e.ist.kombi && e.ist.kombi.entladen),
        leistungsText(stufe.kombi && stufe.kombi.entladen),
        istZahl(stufe.delta_entlade_kw) && stufe.delta_entlade_kw > 0
          ? '+ ' + kw(stufe.delta_entlade_kw)
          : (stufe.leistung_gedeckelt_durch_wr ? 'begrenzt Ihr Wechselrichter' : null));
      wertSpalte('Laden',
        leistungsText(e.ist.kombi && e.ist.kombi.laden),
        leistungsText(stufe.kombi && stufe.kombi.laden),
        null);
      karte.appendChild(werte);

      /*
       * Der Preis, um den es wirklich geht: Zusatzmodule × Modulpreis. Die
       * Differenz zweier Komplettspeicher bleibt nur als Rückfall, wenn der
       * Shop kein Einzelmodul führt, und wird dann auch so benannt.
       */
      if (istZahl(stufe.nachruest_preis_cents)) {
        var preis = el('p', 'iv-stufe__preis');
        preis.appendChild(el('b', null, euro(stufe.nachruest_preis_cents)));
        preis.appendChild(document.createTextNode(' für die Nachrüstung ('
          + stufe.delta_module + ' × ' + euro(stufe.modul_preis_cents) + ' je Modul, ohne Montage)'));
        karte.appendChild(preis);
      } else if (istZahl(stufe.delta_preis_cents)) {
        var preisHinweis = el('p', 'iv-stufe__preisnotiz');
        preisHinweis.appendChild(document.createTextNode(
          'Zum Vergleich: Als Komplettspeicher kostet diese Größe '
          + (stufe.delta_preis_cents > 0 ? euro(stufe.delta_preis_cents) + ' mehr' : euro(-stufe.delta_preis_cents) + ' weniger')
          + ' als Ihre heutige. Den Preis fürs Nachrüsten einzelner Module nennen wir Ihnen gerne.'));
        karte.appendChild(preisHinweis);
      }

      var fuss = el('div', 'iv-karte__fuss');
      fuss.appendChild(knopf('iv-textknopf', 'Details, Bedingungen und Quellen', function () {
        zeigeStufenDetail(stufe, e);
      }));
      if (stufe.modul_handle) {
        var am = shopLink(produktAdresse(stufe.modul_handle, stufe.modul_variante_id),
          'Erweiterungsmodul im Shop', 'iv-knopf iv-knopf--gold iv-knopf--klein');
        am.addEventListener('click', function () { emit('lead_klick', { iv_ziel: 'modul', iv_handle: stufe.modul_handle }); });
        fuss.appendChild(am);
      } else if (stufe.speicher_handle) {
        var a = shopLink(produktAdresse(stufe.speicher_handle, stufe.speicher_variante_id), 'Diese Größe im Shop',
          'iv-knopf iv-knopf--gold iv-knopf--klein');
        a.addEventListener('click', function () { emit('lead_klick', { iv_ziel: 'produkt', iv_handle: stufe.speicher_handle }); });
        fuss.appendChild(a);
      }
      karte.appendChild(fuss);
      return karte;
    }

    /*
     * Was die Karte bewusst nicht zeigt, steht hier: die vollständige Rechnung,
     * die Bedingungen der Freigabe und der Beleg mit Datum.
     */
    function zeigeStufenDetail(stufe, e) {
      var inhalt = el('div');
      inhalt.appendChild(el('p', 'iv-detail__bezug', e.speicher.hersteller + ' ' + e.speicher.name + ' '
        + stufe.groesse + (e.wr ? ' am ' + e.wr.hersteller + ' ' + e.wr.name : '')));

      var werte = el('section', 'iv-detail__block');
      werte.appendChild(el('h3', null, 'Werte dieser Ausbaustufe'));
      var dl = el('dl', 'iv-detail__liste');
      function zeile(label, wert) {
        dl.appendChild(el('dt', null, label));
        var dd = el('dd', null, wert || FEHLT);
        if (!wert) dd.className = 'iv-kennzahl--offen';
        dl.appendChild(dd);
      }
      zeile('Nutzbare Kapazität', kwh(stufe.kapazitaet_kwh));
      zeile('Module', istZahl(stufe.module) ? String(stufe.module) : null);
      zeile('Entladen in dieser Kombination', leistungsText(stufe.kombi && stufe.kombi.entladen));
      zeile('Laden in dieser Kombination', leistungsText(stufe.kombi && stufe.kombi.laden));
      if (istZahl(stufe.nachruest_preis_cents)) {
        zeile('Nachrüstung (' + stufe.delta_module + (stufe.delta_module === 1 ? ' Modul' : ' Module') + ')',
          euro(stufe.nachruest_preis_cents));
      }
      zeile('Preis als Komplettspeicher', euro(stufe.speicher_preis_cents));
      werte.appendChild(dl);
      if (istZahl(stufe.nachruest_preis_cents)) {
        werte.appendChild(el('p', 'iv-detail__erklaerung',
          'Der Nachrüstpreis rechnet Zusatzmodule mal Modulpreis aus dem Shop. Montage und eventuelle '
          + 'Anpassungen an Ihrer Anlage kommen dazu. Ihr Fachbetrieb oder wir nennen Ihnen den Endpreis.'));
      } else if (istZahl(stufe.delta_preis_cents)) {
        werte.appendChild(el('p', 'iv-detail__erklaerung',
          'Der Preisunterschied vergleicht zwei Komplettspeicher. Er ist nicht der Preis einer '
          + 'Nachrüstung. Was das Nachrüsten einzelner Module kostet, rechnen wir Ihnen gerne aus.'));
      }
      if (stufe.kombi && stufe.kombi.entladen && stufe.kombi.entladen.unvollstaendig) {
        werte.appendChild(el('p', 'iv-detail__erklaerung',
          'Für diese Rechnung fehlt uns noch ein Wert aus dem Datenblatt. Der angezeigte Wert ist '
          + 'deshalb eine Obergrenze.'));
      }
      inhalt.appendChild(werte);

      if (stufe.einschraenkungen && stufe.einschraenkungen.length) {
        var bed = el('section', 'iv-detail__block');
        bed.appendChild(el('h3', null, 'Damit die Kombination bestätigt bleibt'));
        var ul = el('ul', 'iv-detail__auflagen');
        stufe.einschraenkungen.forEach(function (t) { ul.appendChild(el('li', null, t)); });
        bed.appendChild(ul);
        inhalt.appendChild(bed);
      }

      if (stufe.belege && stufe.belege.length) {
        var beleg = el('section', 'iv-detail__block');
        beleg.appendChild(el('h3', null, 'Quellen'));
        beleg.appendChild(baueBelegListe(stufe.belege, stufe.bestaetigungen));
        inhalt.appendChild(beleg);
      }

      var aktionen = el('div', 'iv-detail__aktionen');
      if (stufe.speicher_handle) {
        aktionen.appendChild(shopLink(produktAdresse(stufe.speicher_handle, stufe.speicher_variante_id), 'Zum Produkt im Shop',
          'iv-knopf iv-knopf--gold'));
      }
      aktionen.appendChild(kontaktLink('Erweiterung besprechen', 'iv-knopf iv-knopf--leise'));
      inhalt.appendChild(aktionen);

      overlay.zeige(e.speicher.name + ' ' + stufe.groesse, inhalt);
      emit('detail_geoeffnet', { iv_aufgabe: 'erweitern', iv_eintrag: stufe.groesse });
    }

    function bauePraxisHinweise() {
      var bereich = el('section', 'iv-praxis');
      bereich.appendChild(el('h3', 'iv-praxis__titel', 'Worauf Sie beim Erweitern achten sollten'));
      if (!hinweise || !hinweise.erweiterung) {
        var p = el('p', 'iv-praxis__leer',
          'Was beim Nachrüsten Ihres Turms zu beachten ist, besprechen wir gerne persönlich. '
          + 'das hängt von Alter, Zustand und Firmware Ihrer Anlage ab.');
        bereich.appendChild(p);
        return bereich;
      }
      var marke = el('p', 'iv-praxis__marke', hinweise.kennzeichnung);
      bereich.appendChild(marke);
      ['im_selben_turm', 'zweiter_turm', 'nutzen'].forEach(function (schluessel) {
        var block = hinweise.erweiterung[schluessel];
        if (!block) return;
        var d = el('details', 'iv-akkordeon');
        var s = el('summary', null, block.titel);
        d.appendChild(s);
        d.appendChild(el('p', 'iv-akkordeon__text', block.einleitung));
        var ul = el('ul', 'iv-akkordeon__liste');
        block.punkte.forEach(function (t) { ul.appendChild(el('li', null, t)); });
        d.appendChild(ul);
        bereich.appendChild(d);
      });
      bereich.appendChild(el('p', 'iv-praxis__fuss', hinweise.verbindlichkeit));
      return bereich;
    }

    // ------------------------------------------------------------- Belege ----

    function baueBelegListe(belege, bestaetigungen) {
      var box = el('div', 'iv-belege');
      box.appendChild(el('p', 'iv-belege__titel', 'Belege'));
      var ul = el('ul');
      (belege || []).forEach(function (b) {
        var q = daten.quellen[b.quelle];
        if (!q) return;
        var li = el('li');
        li.appendChild(el('strong', null, q.titel));
        li.appendChild(el('span', 'iv-belege__meta',
          q.herausgeber + ' · Stand ' + q.stand));
        ul.appendChild(li);
      });
      (bestaetigungen || []).forEach(function (b) {
        var q = daten.quellen[b.quelle];
        if (!q) return;
        var li = el('li');
        li.appendChild(el('strong', null, q.titel));
        li.appendChild(el('span', 'iv-belege__meta',
          'bestätigt zusätzlich · ' + q.herausgeber + ' · Stand ' + q.stand));
        ul.appendChild(li);
      });
      box.appendChild(ul);
      return box;
    }

    // ------------------------------------------------------- Detail-Overlay --

    function zeigeDetail(e, modus, ergebnis) {
      var inhalt = el('div');

      var kopf = el('div', 'iv-detail__kopf');
      kopf.appendChild(herstellerMarke(e.hersteller));
      kopf.appendChild(el('h2', 'iv-detail__titel', modus === 'speicher' ? (e.bezeichnung ? e.name + ' — ' + e.bezeichnung : e.name + ' ' + e.groesse) : e.name));
      inhalt.appendChild(kopf);

      var gegen = modus === 'speicher'
        ? ergebnis.wr.hersteller + ' ' + ergebnis.wr.name
        : ergebnis.speicher.hersteller + ' ' + ergebnis.speicher.name + ' ' + ergebnis.speicher.groesse;
      inhalt.appendChild(el('p', 'iv-detail__bezug', 'In Kombination mit ' + gegen));

      // Leistungsrechnung
      var leistung = el('section', 'iv-detail__block');
      leistung.appendChild(el('h3', null, 'Leistung in dieser Kombination'));
      leistung.appendChild(rechenweg('Entladen', e.kombi && e.kombi.entladen, modus, e, ergebnis, 'entladen'));
      leistung.appendChild(rechenweg('Laden', e.kombi && e.kombi.laden, modus, e, ergebnis, 'laden'));
      leistung.appendChild(el('p', 'iv-detail__erklaerung',
        'Es gilt immer der kleinste Wert der Kette, mehr kann die Kombination physikalisch nicht. '
        + 'Beim Entladen zählt zusätzlich die AC-Nennleistung des Wechselrichters, weil der Strom '
        + 'über sie ins Hausnetz geht.'));
      inhalt.appendChild(leistung);

      // Preis
      var preisBlock = el('section', 'iv-detail__block');
      preisBlock.appendChild(el('h3', null, 'Preis'));
      var tab = el('dl', 'iv-detail__liste');
      function zeile(label, wert) {
        if (!wert) return;
        tab.appendChild(el('dt', null, label));
        tab.appendChild(el('dd', null, wert));
      }
      zeile('Speicher', euro(e.preis.speicher_preis_cents));
      zeile('Wechselrichter', euro(e.preis.wr_preis_cents));
      if (e.preis.wr_zuschlag_text) {
        zeile('Pflicht-Freischaltung', istZahl(e.preis.wr_zuschlag_cents)
          ? euro(e.preis.wr_zuschlag_cents) + ' — ' + e.preis.wr_zuschlag_text
          : e.preis.wr_zuschlag_text + ' (Preis unbekannt)');
      }
      zeile('System gesamt', euro(e.preis.gesamt_preis_cents));
      zeile('Preis pro kWh (Speicher)', istZahl(e.preis.speicher_eur_pro_kwh) ? euroGenau(e.preis.speicher_eur_pro_kwh) : null);
      zeile('Preis pro kWh (System)', istZahl(e.preis.eur_pro_kwh_nutzbar) ? euroGenau(e.preis.eur_pro_kwh_nutzbar) : null);
      preisBlock.appendChild(tab);
      if (!istZahl(e.preis.gesamt_preis_cents)) {
        preisBlock.appendChild(el('p', 'iv-detail__erklaerung',
          'Ein Gesamtpreis erscheint nur, wenn beide Geräte einen Shop-Preis haben. Wir schätzen nichts.'));
      }
      inhalt.appendChild(preisBlock);

      // Gerätedaten
      var geraet = el('section', 'iv-detail__block');
      geraet.appendChild(el('h3', null, 'Datenblattwerte'));
      var gl = el('dl', 'iv-detail__liste');
      function gzeile(label, wert, zusatz) {
        gl.appendChild(el('dt', null, label));
        var dd = el('dd', null, wert || FEHLT);
        if (!wert) dd.className = 'iv-kennzahl--offen';
        if (zusatz) dd.appendChild(el('span', 'iv-detail__zusatz', zusatz));
        gl.appendChild(dd);
      }
      if (modus === 'speicher') {
        gzeile('Spannungsklasse', klasse(e.spannungsklasse).name, klasse(e.spannungsklasse).erklaerung);
        gzeile('Nutzbare Kapazität', kwh(e.kapazitaet_kwh),
          e.kapazitaet_dokumentiert ? 'laut Datenblatt'
            : (e.kapazitaet_herleitung || 'aus Modulanzahl × Modulenergie hergeleitet'));
        if (istZahl(e.module)) gzeile('Module', String(e.module));
        if (e.chemie) gzeile('Zellchemie', e.chemie);
        gzeile('Garantie', istZahl(e.garantie_jahre) ? e.garantie_jahre + ' Jahre' : null,
          istZahl(e.garantie_zyklen) ? e.garantie_zyklen + ' Zyklen' : 'Zyklenzahl im Datenblatt nicht genannt');
        gzeile('Wechselrichter (AC)', kw(ergebnis.wr.ac_kw));
        gzeile('Batterie-Ladegrenze des WR', kw(ergebnis.wr.bat_lade_kw));
        gzeile('Batterie-Entladegrenze des WR', kw(ergebnis.wr.bat_entlade_kw));
      } else {
        gzeile('AC-Nennleistung', kw(e.ac_kw));
        gzeile('Nutzbare Kapazität des Speichers', kwh(ergebnis.speicher.kapazitaet_kwh));
        gzeile('Garantie des Speichers', istZahl(ergebnis.speicher.garantie_jahre)
          ? ergebnis.speicher.garantie_jahre + ' Jahre' : null);
      }
      geraet.appendChild(gl);
      if (e.leistung_herleitung) geraet.appendChild(el('p', 'iv-detail__erklaerung', e.leistung_herleitung));
      if (e.spec_hinweis) geraet.appendChild(el('p', 'iv-detail__erklaerung', e.spec_hinweis));
      inhalt.appendChild(geraet);

      // Freigabe
      var frei = el('section', 'iv-detail__block');
      frei.appendChild(el('h3', null, 'Quellen'));
      if (e.belege && e.belege.length) {
        frei.appendChild(baueBelegListe(e.belege, e.bestaetigungen));
      } else {
        frei.appendChild(el('p', null,
          'Diese Kombination steht in keiner Herstellerliste, die uns vorliegt. Das ist kein Ausschluss. '
          + 'wir fragen für Sie beim Hersteller nach und antworten mit Beleg.'));
      }
      if (e.einschraenkungen && e.einschraenkungen.length) {
        var ul = el('ul', 'iv-detail__auflagen');
        e.einschraenkungen.forEach(function (t) { ul.appendChild(el('li', null, t)); });
        frei.appendChild(el('p', 'iv-auflagen__titel', 'Damit die Kombination bestätigt bleibt'));
        frei.appendChild(ul);
      }
      inhalt.appendChild(frei);

      var aktionen = el('div', 'iv-detail__aktionen');
      var handle = modus === 'speicher' ? e.preis.speicher_handle : e.preis.wr_handle;
      var detailVid = modus === 'speicher' ? e.preis.speicher_variante_id : e.preis.wr_shop_variante_id;
      if (handle) {
        var a = shopLink(produktAdresse(handle, detailVid), 'Zum Produkt im Shop', 'iv-knopf iv-knopf--gold');
        a.addEventListener('click', function () { emit('lead_klick', { iv_ziel: 'produkt_detail', iv_handle: handle }); });
        aktionen.appendChild(a);
      }
      aktionen.appendChild(kontaktLink('Zu dieser Kombination beraten lassen', 'iv-knopf iv-knopf--leise'));
      inhalt.appendChild(aktionen);

      overlay.zeige(modus === 'speicher' ? (e.bezeichnung ? e.name + ' — ' + e.bezeichnung : e.name + ' ' + e.groesse) : e.name, inhalt);
      emit('detail_geoeffnet', { iv_aufgabe: zustand.aufgabe, iv_eintrag: schluesselVon(e, modus) });
    }

    /*
     * Rechenweg der min()-Regel — nennt jedes Glied mit Wert, damit sichtbar ist,
     * welches Gerät die Grenze setzt und welcher Wert noch fehlt.
     */
    function rechenweg(label, richtung, modus, e, ergebnis, art) {
      var box = el('div', 'iv-rechenweg');
      var kopf = el('p', 'iv-rechenweg__kopf');
      kopf.appendChild(el('span', 'iv-rechenweg__label', label));
      kopf.appendChild(el('strong', 'iv-rechenweg__wert', leistungsText(richtung) || FEHLT));
      box.appendChild(kopf);
      if (!richtung) return box;

      /*
       * Jedes Glied der min()-Kette mit seinem Wert — in beiden Richtungen
       * dieselbe Rechnung, nur unterschiedlich beschafft: In der Speicher-Suche
       * steht der Wechselrichter im Kopf des Ergebnisses, in der
       * Wechselrichter-Suche in der Karte selbst.
       */
      var wrWerte = modus === 'speicher'
        ? { ac: ergebnis.wr.ac_kw, lade: ergebnis.wr.bat_lade_kw, entlade: ergebnis.wr.bat_entlade_kw }
        : { ac: e.ac_kw, lade: e.bat_lade_kw, entlade: e.bat_entlade_kw };

      /*
       * Auch der Speicherwert kann errechnet sein: Nennt sein Datenblatt nur den
       * zulässigen Strom und die Modulnennspannung, ergibt sich die Leistung des
       * Turms erst aus Strom × Turmspannung. Bis 2026-08-16 war das unsichtbar —
       * und ausgerechnet dort steckte der Fehler, der eine AlphaESS 9.3S am T20
       * wie ein 5-kW-System aussehen ließ. Was gerechnet ist, sagt die Zeile
       * jetzt selbst, genau wie auf der Wechselrichterseite.
       */
      var speicherZusatz = richtung.speicher_herkunft === 'berechnet'
        ? ' — Batteriestrom × Turmspannung, aus Angaben im Hersteller-Datenblatt errechnet'
        : '';

      var glieder = [];
      if (art === 'entladen') {
        glieder.push({ name: 'Wechselrichter, Batterie-Entladegrenze', wert: wrWerte.entlade });
        glieder.push({ name: 'Wechselrichter, AC-Nennleistung', wert: wrWerte.ac });
        glieder.push({ name: 'Speicher, Entladeleistung' + speicherZusatz, wert: e.speicher_entlade_kw });
      } else {
        glieder.push({ name: 'Wechselrichter, Batterie-Ladegrenze', wert: wrWerte.lade });
        glieder.push({ name: 'Speicher, Ladeleistung' + speicherZusatz, wert: e.speicher_lade_kw });
      }
      /*
       * Manche Herstellerlisten geben die zulässige DC-Leistung nicht je Gerät an,
       * sondern je Paarung — dann gehört sie sichtbar in die Kette, sonst wirkt das
       * Ergebnis wie ein Rechenfehler (die Kette zeigte größere Zahlen als das Fazit).
       */
      if (istZahl(richtung.kombi_grenze_kw)) {
        glieder.push({ name: 'Herstellerliste, Grenze für genau diese Paarung', wert: richtung.kombi_grenze_kw });
      }
      /*
       * Der errechnete Wert wird ausdrücklich als solcher benannt: Er stammt aus zwei
       * Datenblattangaben (Batteriestrom des Geräts × Turmspannung), aber kein Hersteller
       * hat ihn für diese Paarung ausgesprochen. Das darf der Kunde sehen.
       */
      if (istZahl(richtung.berechnete_grenze_kw)) {
        glieder.push({
          name: 'Batteriestrom × Turmspannung, aus Angaben im Hersteller-Datenblatt errechnet',
          wert: richtung.berechnete_grenze_kw,
        });
      }

      var ul = el('ul', 'iv-rechenweg__glieder');
      glieder.forEach(function (g) {
        var li = el('li');
        li.appendChild(el('span', null, g.name));
        li.appendChild(el('b', istZahl(g.wert) ? null : 'iv-kennzahl--offen',
          kw(g.wert) || FEHLT));
        ul.appendChild(li);
      });
      box.appendChild(ul);

      if (richtung.begrenzt_durch) {
        box.appendChild(el('p', 'iv-rechenweg__fazit',
          richtung.begrenzt_durch === 'kombination'
            ? 'Der Hersteller gibt für genau diese Paarung eine eigene Grenze an. Sie liegt unter dem, was jedes Gerät für sich könnte.'
            : richtung.begrenzt_durch === 'berechnet'
              ? 'Diesen Wert haben wir aus dem Datenblatt errechnet. Der Wechselrichter lässt am Batterieeingang nur einen bestimmten Strom zu. Dieser Speicherturm hat dafür zu wenig Spannung. Der Hersteller selbst nennt für diese Paarung keinen Wert.'
              : richtung.begrenzt_durch === 'wr'
                ? 'Der Wechselrichter setzt die Grenze.'
                : richtung.speicher_herkunft === 'berechnet'
                  ? 'Der Speicher setzt die Grenze. Diesen Wert haben wir aus dem Datenblatt '
                    + 'errechnet: Es nennt den zulässigen Strom und die Spannung eines Moduls, '
                    + 'aber keine Leistung für den ganzen Turm. Mehr Module bedeuten mehr '
                    + 'Spannung — und damit mehr Leistung.'
                  : 'Der Speicher setzt die Grenze.'));
      }
      if (richtung.unvollstaendig) {
        box.appendChild(el('p', 'iv-rechenweg__offen',
          'Für diese Rechnung fehlt noch ein Datenblattwert. Der angezeigte Wert ist deshalb eine Obergrenze.'));
      }
      return box;
    }

    // ---------------------------------------------------------- Vergleich ----

    /*
     * Die Vergleichsleiste wird an Ort und Stelle aktualisiert, nicht über einen
     * Neuaufbau der Liste: Ein Häkchen darf die Seite nicht springen lassen und
     * die Scrollposition nicht verlieren.
     */
    var vergleichsLeiste = null;

    function baueVergleichsLeiste(modus, ergebnis) {
      vergleichsLeiste = el('div', 'iv-vergleichsleiste');
      fuelleVergleichsLeiste(modus, ergebnis);
      return vergleichsLeiste;
    }

    function fuelleVergleichsLeiste(modus, ergebnis) {
      if (!vergleichsLeiste) return;
      leere(vergleichsLeiste);
      vergleichsLeiste.className = 'iv-vergleichsleiste'
        + (zustand.vergleich.length ? '' : ' iv-versteckt');
      if (!zustand.vergleich.length) return;
      vergleichsLeiste.appendChild(el('strong', null,
        zustand.vergleich.length + ' von max. ' + MAX_VERGLEICH + ' ausgewählt'));
      var reihe = el('div', 'iv-knopfreihe');
      reihe.appendChild(knopf('iv-knopf iv-knopf--leise iv-knopf--klein', 'Auswahl löschen', function () {
        zustand.vergleich = [];
        var gewaehlte = ergebnisBereich.querySelectorAll('.iv-vzeile--gewaehlt');
        for (var i = 0; i < gewaehlte.length; i++) {
          gewaehlte[i].className = gewaehlte[i].className.replace(' iv-vzeile--gewaehlt', '');
          var box = gewaehlte[i].querySelector('input[type=checkbox]');
          if (box) box.checked = false;
        }
        fuelleVergleichsLeiste(modus, ergebnis);
      }));
      var vgl = knopf('iv-knopf iv-knopf--gold iv-knopf--klein', 'Vergleichen', function () {
        zeigeVergleich(modus, ergebnis);
      });
      vgl.disabled = zustand.vergleich.length < 2;
      reihe.appendChild(vgl);
      vergleichsLeiste.appendChild(reihe);
    }

    function zeigeVergleich(modus, ergebnis) {
      var alle = ergebnis.freigegeben;
      var gewaehlt = zustand.vergleich.map(function (id) {
        for (var i = 0; i < alle.length; i++) if (schluesselVon(alle[i], modus) === id) return alle[i];
        return null;
      }).filter(Boolean);
      if (gewaehlt.length < 2) return;

      var huelle = el('div', 'iv-tabellen-huelle');
      var tab = el('table', 'iv-vergleich');
      var thead = el('thead');
      var kopfZeile = el('tr');
      kopfZeile.appendChild(el('th', 'iv-vergleich__ecke', ''));
      gewaehlt.forEach(function (e) {
        var th = el('th');
        th.appendChild(el('span', 'iv-vergleich__marke', e.hersteller));
        th.appendChild(el('span', 'iv-vergleich__name', modus === 'speicher' ? (e.bezeichnung ? e.name + ' — ' + e.bezeichnung : e.name + ' ' + e.groesse) : e.name));
        kopfZeile.appendChild(th);
      });
      thead.appendChild(kopfZeile);
      tab.appendChild(thead);

      var tbody = el('tbody');
      function reihe(label, werte) {
        var tr = el('tr');
        tr.appendChild(el('th', 'iv-vergleich__label', label));
        werte.forEach(function (w) {
          var td = el('td', w ? null : 'iv-kennzahl--offen', w || FEHLT);
          tr.appendChild(td);
        });
        tbody.appendChild(tr);
      }
      reihe('Kompatibilität', gewaehlt.map(function (e) {
        return e.status === 'freigegeben' ? 'belegt' : 'kein Beleg';
      }));
      reihe('Preis', gewaehlt.map(function (e) {
        return euro(modus === 'speicher' ? e.preis.speicher_preis_cents : e.preis.wr_preis_effektiv_cents);
      }));
      if (modus === 'speicher') {
        reihe('Kapazität', gewaehlt.map(function (e) { return kwh(e.kapazitaet_kwh); }));
        reihe('Preis pro kWh', gewaehlt.map(function (e) {
          return istZahl(e.preis.speicher_eur_pro_kwh) ? euroGenau(e.preis.speicher_eur_pro_kwh) : null;
        }));
        reihe('Garantie', gewaehlt.map(function (e) {
          return istZahl(e.garantie_jahre) ? e.garantie_jahre + ' Jahre' : null;
        }));
      } else {
        reihe('AC-Nennleistung', gewaehlt.map(function (e) { return kw(e.ac_kw); }));
      }
      reihe('Entladen', gewaehlt.map(function (e) { return leistungsText(e.kombi && e.kombi.entladen); }));
      reihe('Laden', gewaehlt.map(function (e) { return leistungsText(e.kombi && e.kombi.laden); }));
      reihe('System gesamt', gewaehlt.map(function (e) { return euro(e.preis.gesamt_preis_cents); }));
      reihe('Verfügbarkeit', gewaehlt.map(function (e) {
        var v = modus === 'speicher' ? e.preis.speicher_verfuegbar : e.preis.wr_verfuegbar;
        return v === true ? 'sofort bestellbar' : (v === false ? 'nicht lieferbar' : null);
      }));
      reihe('Auflagen', gewaehlt.map(function (e) {
        return e.einschraenkungen && e.einschraenkungen.length ? e.einschraenkungen.join(' · ') : null;
      }));

      // Abschlusszeile mit dem Weg in den Shop — der Vergleich soll nicht in
      // einer Sackgasse enden, sondern dort, wo man bestellen kann.
      var aktionsZeile = el('tr');
      aktionsZeile.appendChild(el('th', 'iv-vergleich__label', ''));
      gewaehlt.forEach(function (e) {
        var td = el('td');
        var handle = modus === 'speicher' ? e.preis.speicher_handle : e.preis.wr_handle;
        var vvid = modus === 'speicher' ? e.preis.speicher_variante_id : e.preis.wr_shop_variante_id;
        if (handle) {
          var a = shopLink(produktAdresse(handle, vvid), 'Zum Produkt', 'iv-knopf iv-knopf--gold iv-knopf--winzig');
          a.addEventListener('click', function () { emit('lead_klick', { iv_ziel: 'produkt_vergleich', iv_handle: handle }); });
          td.appendChild(a);
        } else {
          td.appendChild(el('span', 'iv-kennzahl--offen', 'Preis auf Anfrage'));
        }
        aktionsZeile.appendChild(td);
      });
      tbody.appendChild(aktionsZeile);
      tab.appendChild(tbody);
      huelle.appendChild(tab);

      var inhalt = el('div');
      inhalt.appendChild(huelle);
      overlay.zeige('Direktvergleich', inhalt);
      emit('vergleich_geoeffnet', { iv_anzahl: gewaehlt.length });
    }

    // ------------------------------------------------------------- Drucken ---

    function drucke(ergebnis, modus) {
      var bereich = document.getElementById('druckbereich');
      if (!bereich) { window.print(); return; }
      leere(bereich);
      bereich.setAttribute('aria-hidden', 'true');
      bereich.appendChild(el('h1', null, 'Kompatibilitätsberater — Ergebnis'));
      bereich.appendChild(el('p', null, zusammenfassungsText()));
      bereich.appendChild(el('p', null, 'Datenstand der Herstellerangaben: ' + (ergebnis.stand || daten.stand)
        + (preise && preise.quelle ? ' · Preise: Stand ' + preise.quelle.abruf_datum : '')));
      bereich.appendChild(el('p', null,
        'Preise sind Richtwerte; maßgeblich ist der Shop-Preis zum Bestellzeitpunkt.'));
      /*
       * Der Ausdruck wandert erfahrungsgemäß zum Elektrobetrieb oder in die
       * Ablage — losgelöst von der Seite. Der Hinweis muss deshalb mit aufs
       * Papier, sonst steht dort eine Liste ohne ihren Vorbehalt.
       */
      bereich.appendChild(el('p', 'iv-druck__hinweis',
        'Unverbindliche Orientierung, keine Zusicherung. Angaben aus Herstellerdokumenten ohne '
        + 'Gewähr; Hersteller ändern ihre Listen laufend. Verbindlich sind die aktuellen '
        + 'Herstellerunterlagen und unser Angebot.'));

      var basis = ergebnis.freigegeben.slice();
      var liste = engine.sortiereNach(engine.filtereErgebnis(basis, engineFilter(modus)), zustand.sortierung);
      liste.forEach(function (e) {
        var block = el('div', 'iv-druck__block');
        block.appendChild(el('h2', null, e.hersteller + ' ' + (modus === 'speicher' ? (e.bezeichnung ? e.name + ' — ' + e.bezeichnung : e.name + ' ' + e.groesse) : e.name)));
        var zeilen = [
          ['Freigabe', e.status === 'freigegeben' ? 'belegt' : 'kein Herstellerbeleg'],
          ['Preis', euro(modus === 'speicher' ? e.preis.speicher_preis_cents : e.preis.wr_preis_effektiv_cents)],
          modus === 'speicher' ? ['Kapazität', kwh(e.kapazitaet_kwh)] : ['AC-Nennleistung', kw(e.ac_kw)],
          ['Entladen', leistungsText(e.kombi && e.kombi.entladen)],
          ['Laden', leistungsText(e.kombi && e.kombi.laden)],
          ['System gesamt', euro(e.preis.gesamt_preis_cents)],
        ];
        var dl = el('dl');
        zeilen.forEach(function (z) {
          dl.appendChild(el('dt', null, z[0]));
          dl.appendChild(el('dd', null, z[1] || FEHLT));
        });
        block.appendChild(dl);
        if (e.einschraenkungen && e.einschraenkungen.length) {
          block.appendChild(el('p', null, 'Auflagen: ' + e.einschraenkungen.join(' · ')));
        }
        (e.belege || []).forEach(function (b) {
          var q = daten.quellen[b.quelle];
          if (q) block.appendChild(el('p', null, 'Beleg: ' + q.titel + ' (' + q.herausgeber + ', Stand ' + q.stand + ')'));
        });
        bereich.appendChild(block);
      });
      emit('pdf_export', { iv_aufgabe: zustand.aufgabe, iv_anzahl: liste.length });
      window.print();
      if (window.addEventListener) {
        window.addEventListener('afterprint', function einmal() {
          leere(bereich);
          window.removeEventListener('afterprint', einmal);
        });
      }
    }

    // ----------------------------------------------------------- Deep-Link ---

    /* Die Logik lebt seit E6 in app/deeplink.js (rein, getestet) — hier bleibt
     * nur das window-I/O. Deep-Link ist Komfort, nie Voraussetzung. */
    function schreibeHash() {
      try {
        var dl = window.IVBeraterDeeplink;
        if (!dl) return;
        var neu = dl.hashAusZustand(zustand);
        if (window.location.hash !== neu) window.history.replaceState(null, '', neu);
      } catch (fehler) { /* Deep-Link ist Komfort, nie Voraussetzung */ }
    }

    function leseHash() {
      try {
        var dl = window.IVBeraterDeeplink;
        if (!dl) return;
        var gelesen = dl.zustandAusHash(window.location.hash, daten,
          AUFGABEN.map(function (a) { return a.id; }));
        for (var k in gelesen) {
          if (Object.prototype.hasOwnProperty.call(gelesen, k)) zustand[k] = gelesen[k];
        }
        if (auswahlVollstaendig()) zustand.auswahlOffen = false;
      } catch (fehler) { /* kaputter Hash darf die Seite nie blockieren */ }
    }

    // ------------------------------------------------------------ Rendern ----

    function zeichneAlles() {
      zeichneReiter();
      zeichneAuswahl();
      zeichneErgebnis();
    }

    leseHash();
    /*
     * VOR dem ersten Zeichnen melden. Andersherum verschluckt ein Deeplink die
     * Stufe: Bringt der Hash schon eine Auswahl mit (`#speicher_finden&wr=…`),
     * meldet `zeichneAlles()` zuerst `ergebnis_angezeigt`; die Stufenleiter in
     * app/clarity.js steht damit auf `ergebnis` und verwirft das nachfolgende
     * `geoeffnet` als Rückschritt. Genau daran lag es, dass im August 2026
     * `iv_aufgabe = speicher_finden` (45 Sitzungen) über `geoeffnet` (37) stand
     * und `ergebnis` (27) über `ausgewaehlt` (18).
     */
    emit('geoeffnet', { iv_aufgabe: zustand.aufgabe });
    zeichneAlles();
    schreibeDatenstand();
    ladePreiseLive();

    function ladePreiseLive() {
      var quelle = window.IVPreisQuelle;
      if (!quelle || !quelle.laden) { preisHerkunft = PS.ohneQuelle(preisHerkunft); zeichneErgebnis(); return; }
      quelle.laden(preise).then(function (ergebnis) {
        preise = ergebnis.preise;
        preisHerkunft = PS.nachAbruf(ergebnis);
        emit('preise_geladen', { iv_quelle: ergebnis.quelle, iv_aktualisiert: ergebnis.aktualisiert });
        zeichneErgebnis();
        schreibeDatenstand();
      });
    }

    /*
     * Hier weiterhin ohne Datum — das steht seit dem Kennzahlen-Streifen ganz
     * oben, und zweimal dieselbe Angabe auf einer Seite wirft die Frage auf,
     * welche der beiden gilt.
     *
     * Die frühere Begründung („Zeitstempel wirken technisch") gilt in der Sache
     * weiter, richtet sich aber gegen die FORM, nicht gegen die Angabe: Der
     * Streifen schreibt „9. August 2026" aus, keinen ISO-Stempel. Sichtbarer
     * Datenstand ist eine harte Vorgabe (CLAUDE.md: jede Aussage trägt Quelle
     * und Datum) — sie hier ganz wegzulassen war die falsche Auflösung.
     */
    function schreibeDatenstand() {
      var ziel = document.querySelector('[data-stand]');
      if (!ziel) return;
      var text = 'Alle Kompatibilitätsangaben aus offiziellen Herstellerlisten';
      if (preisHerkunft.quelle === 'live') text += '  ·  Preise live aus dem Shop';
      ziel.textContent = text;
    }
  }

  // ------------------------------------------------------------- Overlay -----

  function baueOverlay() {
    var huelle = el('div', 'iv-overlay');
    huelle.setAttribute('hidden', 'hidden');
    var dialog = el('div', 'iv-dialog');
    dialog.setAttribute('role', 'dialog');
    dialog.setAttribute('aria-modal', 'true');
    var kopf = el('div', 'iv-dialog__kopf');
    var titel = el('h2', 'iv-dialog__titel');
    titel.id = 'iv-dialog-titel';
    dialog.setAttribute('aria-labelledby', 'iv-dialog-titel');
    var schliessen = el('button', 'iv-dialog__schliessen', '×');
    schliessen.type = 'button';
    schliessen.setAttribute('aria-label', 'Schließen');
    kopf.appendChild(titel);
    kopf.appendChild(schliessen);
    var koerper = el('div', 'iv-dialog__koerper');
    dialog.appendChild(kopf);
    dialog.appendChild(koerper);
    huelle.appendChild(dialog);

    var vorherFokus = null;

    function zu() {
      huelle.setAttribute('hidden', 'hidden');
      document.body.classList.remove('iv-fixiert');
      if (vorherFokus && vorherFokus.focus) vorherFokus.focus();
    }

    schliessen.addEventListener('click', zu);
    huelle.addEventListener('click', function (ev) { if (ev.target === huelle) zu(); });
    document.addEventListener('keydown', function (ev) {
      if (huelle.hasAttribute('hidden')) return;
      if (ev.key === 'Escape') { zu(); return; }
      if (ev.key !== 'Tab') return;
      // Fokus im Dialog halten
      var fokusierbar = dialog.querySelectorAll('a[href], button:not([disabled]), input, select, textarea, [tabindex]:not([tabindex="-1"])');
      if (!fokusierbar.length) return;
      var erster = fokusierbar[0];
      var letzter = fokusierbar[fokusierbar.length - 1];
      if (ev.shiftKey && document.activeElement === erster) { ev.preventDefault(); letzter.focus(); }
      else if (!ev.shiftKey && document.activeElement === letzter) { ev.preventDefault(); erster.focus(); }
    });

    return {
      knoten: huelle,
      zeige: function (ueberschrift, inhalt) {
        vorherFokus = document.activeElement;
        titel.textContent = ueberschrift;
        leere(koerper);
        koerper.appendChild(inhalt);
        huelle.removeAttribute('hidden');
        document.body.classList.add('iv-fixiert');
        koerper.scrollTop = 0;
        schliessen.focus();
      },
    };
  }

  function zeigeFallback(wurzel) {
    leere(wurzel);
    var box = el('div', 'iv-hinweisbox');
    box.appendChild(el('h3', null, 'Der Berater konnte nicht geladen werden'));
    box.appendChild(el('p', null,
      'Sprechen Sie uns an. Wir prüfen Ihre Wunschkombination persönlich und kostenlos.'));
    box.appendChild(kontaktLink('Zum Kontakt', 'iv-knopf iv-knopf--primaer'));
    wurzel.appendChild(box);
  }

  /*
   * Start, sobald der Wurzelknoten existiert — nicht erst bei DOMContentLoaded.
   * In der Standalone-Seite stehen die Skripte am Ende des <body>, in Shopify
   * kann die Section sie an beliebiger Stelle einbinden. Beide Fälle deckt diese
   * Reihenfolge ab, ohne auf ein Ereignis zu warten, das schon vorbei sein kann.
   */
  function boot() {
    if (document.getElementById('berater-app')) { start(); return; }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', start);
    } else {
      start();
    }
  }
  boot();
})();
